//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AfrRateClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAFREntry(year: number , cancelToken?: CancelToken | undefined): Promise<AfrRateViewModel> {
        let url_ = this.baseUrl + "/api/afr-rate/entry/{year}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAFREntry(_response);
        });
    }

    protected processGetAFREntry(response: AxiosResponse): Promise<AfrRateViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AfrRateViewModel.fromJS(resultData200);
            return Promise.resolve<AfrRateViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AfrRateViewModel>(null as any);
    }

    saveAFREntry(afrReq: AfrRateViewModel , cancelToken?: CancelToken | undefined): Promise<AfrRateViewModel> {
        let url_ = this.baseUrl + "/api/afr-rate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(afrReq);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAFREntry(_response);
        });
    }

    protected processSaveAFREntry(response: AxiosResponse): Promise<AfrRateViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AfrRateViewModel.fromJS(resultData200);
            return Promise.resolve<AfrRateViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AfrRateViewModel>(null as any);
    }

    getParticipantByIds(divisionId: number , cancelToken?: CancelToken | undefined): Promise<ClientViewModel[]> {
        let url_ = this.baseUrl + "/api/afr-rate/participants/{divisionId}";
        if (divisionId === undefined || divisionId === null)
            throw new Error("The parameter 'divisionId' must be defined.");
        url_ = url_.replace("{divisionId}", encodeURIComponent("" + divisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetParticipantByIds(_response);
        });
    }

    protected processGetParticipantByIds(response: AxiosResponse): Promise<ClientViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClientViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientViewModel[]>(null as any);
    }

    getAccountsReceivable(request: AccountsRequest , cancelToken?: CancelToken | undefined): Promise<ReceivableDetailViewModel[]> {
        let url_ = this.baseUrl + "/api/afr-rate/account-receivable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountsReceivable(_response);
        });
    }

    protected processGetAccountsReceivable(response: AxiosResponse): Promise<ReceivableDetailViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReceivableDetailViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReceivableDetailViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReceivableDetailViewModel[]>(null as any);
    }

    getParticipantReceiable(request: ParticipantRequest , cancelToken?: CancelToken | undefined): Promise<ReceiavbleCalculateViewModel[]> {
        let url_ = this.baseUrl + "/api/afr-rate/participant-receivable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetParticipantReceiable(_response);
        });
    }

    protected processGetParticipantReceiable(response: AxiosResponse): Promise<ReceiavbleCalculateViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReceiavbleCalculateViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReceiavbleCalculateViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReceiavbleCalculateViewModel[]>(null as any);
    }

    exportToCSV(request: ReceivableDownloadRequest , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/afr-rate/download-csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToCSV(_response);
        });
    }

    protected processExportToCSV(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportToPDF(request: ReceivableDownloadRequest , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/afr-rate/download-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToPDF(_response);
        });
    }

    protected processExportToPDF(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ApiInfoClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    version(  cancelToken?: CancelToken | undefined): Promise<AppInfo> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVersion(_response);
        });
    }

    protected processVersion(response: AxiosResponse): Promise<AppInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppInfo.fromJS(resultData200);
            return Promise.resolve<AppInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppInfo>(null as any);
    }

    models(  cancelToken?: CancelToken | undefined): Promise<KeystoneModels> {
        let url_ = this.baseUrl + "/api/models";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModels(_response);
        });
    }

    protected processModels(response: AxiosResponse): Promise<KeystoneModels> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KeystoneModels.fromJS(resultData200);
            return Promise.resolve<KeystoneModels>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeystoneModels>(null as any);
    }
}

export class AuthClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    authenticate(request: LoginRequest , cancelToken?: CancelToken | undefined): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginResponse.fromJS(resultData200);
            return Promise.resolve<LoginResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginResponse>(null as any);
    }

    refreshToken(request: RefreshTokenRequest , cancelToken?: CancelToken | undefined): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/auth/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginResponse.fromJS(resultData200);
            return Promise.resolve<LoginResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginResponse>(null as any);
    }
}

export class CarrierClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getCarriers(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfCarrierViewModel> {
        let url_ = this.baseUrl + "/api/carriers?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCarriers(_response);
        });
    }

    protected processGetCarriers(response: AxiosResponse): Promise<QueryResultsOfCarrierViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfCarrierViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfCarrierViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfCarrierViewModel>(null as any);
    }

    saveCarrier(request: CarrierRequest , cancelToken?: CancelToken | undefined): Promise<CarrierDetailViewModel> {
        let url_ = this.baseUrl + "/api/carriers/save-carrier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCarrier(_response);
        });
    }

    protected processSaveCarrier(response: AxiosResponse): Promise<CarrierDetailViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CarrierDetailViewModel.fromJS(resultData200);
            return Promise.resolve<CarrierDetailViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarrierDetailViewModel>(null as any);
    }

    getCarrierById(carrierId: number , cancelToken?: CancelToken | undefined): Promise<CarrierDetailViewModel> {
        let url_ = this.baseUrl + "/api/carriers/{carrierId}";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined.");
        url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCarrierById(_response);
        });
    }

    protected processGetCarrierById(response: AxiosResponse): Promise<CarrierDetailViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CarrierDetailViewModel.fromJS(resultData200);
            return Promise.resolve<CarrierDetailViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarrierDetailViewModel>(null as any);
    }

    getCarrierResourcesByClientId(userId: string | null, clientId: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<CarrierResourceViewModel[]> {
        let url_ = this.baseUrl + "/api/carriers/carrier-documents/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCarrierResourcesByClientId(_response);
        });
    }

    protected processGetCarrierResourcesByClientId(response: AxiosResponse): Promise<CarrierResourceViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CarrierResourceViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CarrierResourceViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarrierResourceViewModel[]>(null as any);
    }
}

export class ClientClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getClient(id: number , cancelToken?: CancelToken | undefined): Promise<ClientViewModel> {
        let url_ = this.baseUrl + "/api/clients/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClient(_response);
        });
    }

    protected processGetClient(response: AxiosResponse): Promise<ClientViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientViewModel.fromJS(resultData200);
            return Promise.resolve<ClientViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientViewModel>(null as any);
    }

    getClients(userIds: string[] | null | undefined, employerId: number | null | undefined, divisionId: number | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, includeLoginHistory: boolean | undefined, includeStatusHistory: boolean | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfClientViewModel> {
        let url_ = this.baseUrl + "/api/clients?";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (employerId !== undefined && employerId !== null)
            url_ += "EmployerId=" + encodeURIComponent("" + employerId) + "&";
        if (divisionId !== undefined && divisionId !== null)
            url_ += "DivisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (includeLoginHistory === null)
            throw new Error("The parameter 'includeLoginHistory' cannot be null.");
        else if (includeLoginHistory !== undefined)
            url_ += "IncludeLoginHistory=" + encodeURIComponent("" + includeLoginHistory) + "&";
        if (includeStatusHistory === null)
            throw new Error("The parameter 'includeStatusHistory' cannot be null.");
        else if (includeStatusHistory !== undefined)
            url_ += "IncludeStatusHistory=" + encodeURIComponent("" + includeStatusHistory) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClients(_response);
        });
    }

    protected processGetClients(response: AxiosResponse): Promise<QueryResultsOfClientViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfClientViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfClientViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfClientViewModel>(null as any);
    }

    export(userIds: string[] | null | undefined, employerId: number | null | undefined, divisionId: number | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, includeLoginHistory: boolean | undefined, includeStatusHistory: boolean | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/clients/export?";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (employerId !== undefined && employerId !== null)
            url_ += "EmployerId=" + encodeURIComponent("" + employerId) + "&";
        if (divisionId !== undefined && divisionId !== null)
            url_ += "DivisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (includeLoginHistory === null)
            throw new Error("The parameter 'includeLoginHistory' cannot be null.");
        else if (includeLoginHistory !== undefined)
            url_ += "IncludeLoginHistory=" + encodeURIComponent("" + includeLoginHistory) + "&";
        if (includeStatusHistory === null)
            throw new Error("The parameter 'includeStatusHistory' cannot be null.");
        else if (includeStatusHistory !== undefined)
            url_ += "IncludeStatusHistory=" + encodeURIComponent("" + includeStatusHistory) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class CustomReportClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    generateCustomReport(request: CustomReportRequestViewModel , cancelToken?: CancelToken | undefined): Promise<CustomReportResultViewModel> {
        let url_ = this.baseUrl + "/api/custom-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateCustomReport(_response);
        });
    }

    protected processGenerateCustomReport(response: AxiosResponse): Promise<CustomReportResultViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomReportResultViewModel.fromJS(resultData200);
            return Promise.resolve<CustomReportResultViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomReportResultViewModel>(null as any);
    }

    generateCustomReportCsv(request: CustomReportRequestViewModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/custom-report/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateCustomReportCsv(_response);
        });
    }

    protected processGenerateCustomReportCsv(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSupportedTables(  cancelToken?: CancelToken | undefined): Promise<Table[]> {
        let url_ = this.baseUrl + "/api/custom-report/tables";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSupportedTables(_response);
        });
    }

    protected processGetSupportedTables(response: AxiosResponse): Promise<Table[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Table.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Table[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Table[]>(null as any);
    }
}

export class DivisionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getDivisions(employerIds: number[] | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfDivisionViewModel> {
        let url_ = this.baseUrl + "/api/divisions?";
        if (employerIds !== undefined && employerIds !== null)
            employerIds && employerIds.forEach(item => { url_ += "EmployerIds=" + encodeURIComponent("" + item) + "&"; });
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDivisions(_response);
        });
    }

    protected processGetDivisions(response: AxiosResponse): Promise<QueryResultsOfDivisionViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfDivisionViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfDivisionViewModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfDivisionViewModel>(null as any);
    }

    getDivisionsForEmployerAdmin(id: string | null , cancelToken?: CancelToken | undefined): Promise<DivisionViewModel[]> {
        let url_ = this.baseUrl + "/api/divisions/employer_admin/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDivisionsForEmployerAdmin(_response);
        });
    }

    protected processGetDivisionsForEmployerAdmin(response: AxiosResponse): Promise<DivisionViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DivisionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DivisionViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DivisionViewModel[]>(null as any);
    }
}

export class DocumentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getDocuments(userId: string | null | undefined, clientId: number | null | undefined, type: DocumentType | null | undefined, timeRange: DocumentTimeRange | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfDocumentViewModel> {
        let url_ = this.baseUrl + "/api/documents?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (timeRange === null)
            throw new Error("The parameter 'timeRange' cannot be null.");
        else if (timeRange !== undefined)
            url_ += "TimeRange=" + encodeURIComponent("" + timeRange) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: AxiosResponse): Promise<QueryResultsOfDocumentViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfDocumentViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfDocumentViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfDocumentViewModel>(null as any);
    }

    updateDocument(request: UpdateDocumentViewModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDocument(_response);
        });
    }

    protected processUpdateDocument(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    uploadDocument(file: FileParameter | null | undefined, documentType: DocumentType | undefined, clientId: number | null | undefined, carrierId: number | null | undefined, divisionId: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<DocumentViewModel> {
        let url_ = this.baseUrl + "/api/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (documentType === null || documentType === undefined)
            throw new Error("The parameter 'documentType' cannot be null.");
        else
            content_.append("DocumentType", documentType.toString());
        if (clientId !== null && clientId !== undefined)
            content_.append("ClientId", clientId.toString());
        if (carrierId !== null && carrierId !== undefined)
            content_.append("CarrierId", carrierId.toString());
        if (divisionId !== null && divisionId !== undefined)
            content_.append("DivisionId", divisionId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDocument(_response);
        });
    }

    protected processUploadDocument(response: AxiosResponse): Promise<DocumentViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentViewModel.fromJS(resultData200);
            return Promise.resolve<DocumentViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentViewModel>(null as any);
    }

    getPlantDocuments(clientId: number | null | undefined, divisionId: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<DocumentViewModel[]> {
        let url_ = this.baseUrl + "/api/documents/plant-documents?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (divisionId !== undefined && divisionId !== null)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlantDocuments(_response);
        });
    }

    protected processGetPlantDocuments(response: AxiosResponse): Promise<DocumentViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentViewModel[]>(null as any);
    }

    deleteDocumentFile(fileName: string | null, type: DocumentType | undefined, divisionId: number | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/documents/delete-document/{fileName}?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (divisionId === null)
            throw new Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDocumentFile(_response);
        });
    }

    protected processDeleteDocumentFile(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteDocumentById(id: number , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDocumentById(_response);
        });
    }

    protected processDeleteDocumentById(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    sendUpdatedDocuments(request: SendUpdatedDocumentsRequestDto , cancelToken?: CancelToken | undefined): Promise<SendUpdatedDocumentsResultDto> {
        let url_ = this.baseUrl + "/api/documents/send-updated-documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendUpdatedDocuments(_response);
        });
    }

    protected processSendUpdatedDocuments(response: AxiosResponse): Promise<SendUpdatedDocumentsResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendUpdatedDocumentsResultDto.fromJS(resultData200);
            return Promise.resolve<SendUpdatedDocumentsResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendUpdatedDocumentsResultDto>(null as any);
    }

    downloadDocumentFile(fileName: string | null, type: DocumentType | undefined, divisionId: number | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents/download-pdf/{fileName}?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (divisionId === null)
            throw new Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadDocumentFile(_response);
        });
    }

    protected processDownloadDocumentFile(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPreviewUrl(documentId: number , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/documents/preview-url/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreviewUrl(_response);
        });
    }

    protected processGetPreviewUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    downloadZippedDocuments(ids: number[] , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents/download-zipped-documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadZippedDocuments(_response);
        });
    }

    protected processDownloadZippedDocuments(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class EmployerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getEmployer(id: number , cancelToken?: CancelToken | undefined): Promise<EmployerDetailViewModel> {
        let url_ = this.baseUrl + "/api/employers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployer(_response);
        });
    }

    protected processGetEmployer(response: AxiosResponse): Promise<EmployerDetailViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployerDetailViewModel.fromJS(resultData200);
            return Promise.resolve<EmployerDetailViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployerDetailViewModel>(null as any);
    }

    getEmployerByUserId(id: string | null , cancelToken?: CancelToken | undefined): Promise<EmployerViewModel[]> {
        let url_ = this.baseUrl + "/api/employers/producer_id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployerByUserId(_response);
        });
    }

    protected processGetEmployerByUserId(response: AxiosResponse): Promise<EmployerViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployerViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmployerViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployerViewModel[]>(null as any);
    }

    getEmployers(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfEmployerViewModel> {
        let url_ = this.baseUrl + "/api/employers?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployers(_response);
        });
    }

    protected processGetEmployers(response: AxiosResponse): Promise<QueryResultsOfEmployerViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfEmployerViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfEmployerViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfEmployerViewModel>(null as any);
    }

    getEmployersByEmployerAdmin(id: string | null , cancelToken?: CancelToken | undefined): Promise<EmployerViewModel[]> {
        let url_ = this.baseUrl + "/api/employers/employer_admin/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployersByEmployerAdmin(_response);
        });
    }

    protected processGetEmployersByEmployerAdmin(response: AxiosResponse): Promise<EmployerViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployerViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmployerViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployerViewModel[]>(null as any);
    }

    saveEmployer(request: EmployerRequest , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/employers/save-employer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveEmployer(_response);
        });
    }

    protected processSaveEmployer(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    sendTaxDocuments(id: number, divisionId: number , cancelToken?: CancelToken | undefined): Promise<SendTaxDocumentsResultDto> {
        let url_ = this.baseUrl + "/api/employers/{id}/divisions/{divisionId}/send-tax-documents";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (divisionId === undefined || divisionId === null)
            throw new Error("The parameter 'divisionId' must be defined.");
        url_ = url_.replace("{divisionId}", encodeURIComponent("" + divisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTaxDocuments(_response);
        });
    }

    protected processSendTaxDocuments(response: AxiosResponse): Promise<SendTaxDocumentsResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendTaxDocumentsResultDto.fromJS(resultData200);
            return Promise.resolve<SendTaxDocumentsResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendTaxDocumentsResultDto>(null as any);
    }

    getUserTaxDocuments(id: number, divisionId: number , cancelToken?: CancelToken | undefined): Promise<UserTaxDocumentViewModel[]> {
        let url_ = this.baseUrl + "/api/employers/{id}/divisions/{divisionId}/tax-documents";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (divisionId === undefined || divisionId === null)
            throw new Error("The parameter 'divisionId' must be defined.");
        url_ = url_.replace("{divisionId}", encodeURIComponent("" + divisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserTaxDocuments(_response);
        });
    }

    protected processGetUserTaxDocuments(response: AxiosResponse): Promise<UserTaxDocumentViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTaxDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserTaxDocumentViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTaxDocumentViewModel[]>(null as any);
    }
}

export class ExampleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getCsv(  cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/examples/csv";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCsv(_response);
        });
    }

    protected processGetCsv(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    findEmployees(query: EmployeeQuery , cancelToken?: CancelToken | undefined): Promise<EmployeeViewModel[]> {
        let url_ = this.baseUrl + "/api/examples/findemployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindEmployees(_response);
        });
    }

    protected processFindEmployees(response: AxiosResponse): Promise<EmployeeViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmployeeViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeViewModel[]>(null as any);
    }

    getPDF(query: EmployeeQuery , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/examples/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPDF(_response);
        });
    }

    protected processGetPDF(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    emailTest(query: EmployeeQuery , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/examples/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmailTest(_response);
        });
    }

    protected processEmailTest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getEmployee(employeeId: number , cancelToken?: CancelToken | undefined): Promise<Employee> {
        let url_ = this.baseUrl + "/api/examples/employee/{employeeId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployee(_response);
        });
    }

    protected processGetEmployee(response: AxiosResponse): Promise<Employee> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Employee.fromJS(resultData200);
            return Promise.resolve<Employee>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Employee>(null as any);
    }

    saveEmployee(employee: Employee , cancelToken?: CancelToken | undefined): Promise<Employee> {
        let url_ = this.baseUrl + "/api/examples/employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employee);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveEmployee(_response);
        });
    }

    protected processSaveEmployee(response: AxiosResponse): Promise<Employee> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Employee.fromJS(resultData200);
            return Promise.resolve<Employee>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Employee>(null as any);
    }

    getStorePickList(  cancelToken?: CancelToken | undefined): Promise<PicklistOption[]> {
        let url_ = this.baseUrl + "/api/examples/storepicks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStorePickList(_response);
        });
    }

    protected processGetStorePickList(response: AxiosResponse): Promise<PicklistOption[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PicklistOption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PicklistOption[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PicklistOption[]>(null as any);
    }
}

export class FileClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    uploadFile(file: FileParameter | null | undefined, carrierId: number | undefined , cancelToken?: CancelToken | undefined): Promise<ProgressDocumentViewModel> {
        let url_ = this.baseUrl + "/api/files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (carrierId === null || carrierId === undefined)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else
            content_.append("CarrierId", carrierId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<ProgressDocumentViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProgressDocumentViewModel.fromJS(resultData200);
            return Promise.resolve<ProgressDocumentViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgressDocumentViewModel>(null as any);
    }

    uploadFilePolicyTransaction(file: FileParameter | null | undefined, carrierId: number | undefined , cancelToken?: CancelToken | undefined): Promise<ProgressDocumentViewModel> {
        let url_ = this.baseUrl + "/api/files/upload-file-transaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (carrierId === null || carrierId === undefined)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else
            content_.append("CarrierId", carrierId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFilePolicyTransaction(_response);
        });
    }

    protected processUploadFilePolicyTransaction(response: AxiosResponse): Promise<ProgressDocumentViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProgressDocumentViewModel.fromJS(resultData200);
            return Promise.resolve<ProgressDocumentViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgressDocumentViewModel>(null as any);
    }

    getFilesUnPublish(  cancelToken?: CancelToken | undefined): Promise<TransactionDocumentViewModel[]> {
        let url_ = this.baseUrl + "/api/files/get-file-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilesUnPublish(_response);
        });
    }

    protected processGetFilesUnPublish(response: AxiosResponse): Promise<TransactionDocumentViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionDocumentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TransactionDocumentViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransactionDocumentViewModel[]>(null as any);
    }

    publishFiles(request: FilesUploadModel , cancelToken?: CancelToken | undefined): Promise<ProgressDocumentViewModel> {
        let url_ = this.baseUrl + "/api/files/publish-files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishFiles(_response);
        });
    }

    protected processPublishFiles(response: AxiosResponse): Promise<ProgressDocumentViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProgressDocumentViewModel.fromJS(resultData200);
            return Promise.resolve<ProgressDocumentViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgressDocumentViewModel>(null as any);
    }

    progress(id: number , cancelToken?: CancelToken | undefined): Promise<ProgressDocumentViewModel> {
        let url_ = this.baseUrl + "/api/files/progress/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProgress(_response);
        });
    }

    protected processProgress(response: AxiosResponse): Promise<ProgressDocumentViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProgressDocumentViewModel.fromJS(resultData200);
            return Promise.resolve<ProgressDocumentViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgressDocumentViewModel>(null as any);
    }

    deleteFilePolicyTransaction(fileName: string | null , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/files/delete-file-transaction/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFilePolicyTransaction(_response);
        });
    }

    protected processDeleteFilePolicyTransaction(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class InvestmentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getInvestmentsByCarrierId(carrierId: number , cancelToken?: CancelToken | undefined): Promise<InvestmentViewModel[]> {
        let url_ = this.baseUrl + "/api/investments/{carrierId}";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined.");
        url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvestmentsByCarrierId(_response);
        });
    }

    protected processGetInvestmentsByCarrierId(response: AxiosResponse): Promise<InvestmentViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvestmentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InvestmentViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvestmentViewModel[]>(null as any);
    }

    getInvestmentDetailById(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<InvesmentDetailViewModel> {
        let url_ = this.baseUrl + "/api/investments/get-investment-detail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvestmentDetailById(_response);
        });
    }

    protected processGetInvestmentDetailById(response: AxiosResponse): Promise<InvesmentDetailViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvesmentDetailViewModel.fromJS(resultData200);
            return Promise.resolve<InvesmentDetailViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvesmentDetailViewModel>(null as any);
    }
}

export class PolicyClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getHistoryPoints(month: number, year: number, userId: string | null, clientId: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<OverViewViewModel> {
        let url_ = this.baseUrl + "/api/policies/{userId}/history-points/{month}-{year}?";
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined.");
        url_ = url_.replace("{month}", encodeURIComponent("" + month));
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHistoryPoints(_response);
        });
    }

    protected processGetHistoryPoints(response: AxiosResponse): Promise<OverViewViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OverViewViewModel.fromJS(resultData200);
            return Promise.resolve<OverViewViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OverViewViewModel>(null as any);
    }

    move(request: MovePolicyRequest , cancelToken?: CancelToken | undefined): Promise<MovePolicyResult> {
        let url_ = this.baseUrl + "/api/policies/move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: AxiosResponse): Promise<MovePolicyResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MovePolicyResult.fromJS(resultData200);
            return Promise.resolve<MovePolicyResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MovePolicyResult>(null as any);
    }

    getAccumulatedLastValuationDate(userId: string | null, clientId: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/api/policies/{userId}/accumulated-last-valuation-date?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccumulatedLastValuationDate(_response);
        });
    }

    protected processGetAccumulatedLastValuationDate(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    deletePlanContributionHistory(item: PlanContributionsHistory , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/policies/delete-plan-contribution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePlanContributionHistory(_response);
        });
    }

    protected processDeletePlanContributionHistory(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteMultiPlanContributionHistory(items: PlanContributionsHistory[] , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/policies/delete-multi-plan-contribution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMultiPlanContributionHistory(_response);
        });
    }

    protected processDeleteMultiPlanContributionHistory(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteAccumulatedValueHítory(item: AccumulatedValuesHistory , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/policies/delete-accumulated-value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccumulatedValueHítory(_response);
        });
    }

    protected processDeleteAccumulatedValueHítory(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteMultiAccumulatedValueHítory(items: AccumulatedValuesHistory[] , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/policies/delete-multi-accumulated-value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMultiAccumulatedValueHítory(_response);
        });
    }

    protected processDeleteMultiAccumulatedValueHítory(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    previewStatement(query: StatementQuery , cancelToken?: CancelToken | undefined): Promise<ParticipantStatementViewModel> {
        let url_ = this.baseUrl + "/api/policies/preview-statement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewStatement(_response);
        });
    }

    protected processPreviewStatement(response: AxiosResponse): Promise<ParticipantStatementViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ParticipantStatementViewModel.fromJS(resultData200);
            return Promise.resolve<ParticipantStatementViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ParticipantStatementViewModel>(null as any);
    }

    downloadStatementCsv(query: StatementQuery , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/policies/download-statement/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadStatementCsv(_response);
        });
    }

    protected processDownloadStatementCsv(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPDF(query: StatementQuery , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/policies/download-statement/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPDF(_response);
        });
    }

    protected processGetPDF(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPDF2(query: StatementQuery , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/policies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPDF2(_response);
        });
    }

    protected processGetPDF2(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ProducerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getProducer(id: number , cancelToken?: CancelToken | undefined): Promise<ProducerViewModel> {
        let url_ = this.baseUrl + "/api/producers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProducer(_response);
        });
    }

    protected processGetProducer(response: AxiosResponse): Promise<ProducerViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProducerViewModel.fromJS(resultData200);
            return Promise.resolve<ProducerViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProducerViewModel>(null as any);
    }

    getProducers(userIds: string[] | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfProducerViewModel> {
        let url_ = this.baseUrl + "/api/producers?";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProducers(_response);
        });
    }

    protected processGetProducers(response: AxiosResponse): Promise<QueryResultsOfProducerViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfProducerViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfProducerViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfProducerViewModel>(null as any);
    }

    saveProducer(producer: ProducerViewModel , cancelToken?: CancelToken | undefined): Promise<ProducerViewModel> {
        let url_ = this.baseUrl + "/api/producers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(producer);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProducer(_response);
        });
    }

    protected processSaveProducer(response: AxiosResponse): Promise<ProducerViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProducerViewModel.fromJS(resultData200);
            return Promise.resolve<ProducerViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProducerViewModel>(null as any);
    }

    getActivedProducers(  cancelToken?: CancelToken | undefined): Promise<ProducerViewModel[]> {
        let url_ = this.baseUrl + "/api/producers/get-actived-producers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivedProducers(_response);
        });
    }

    protected processGetActivedProducers(response: AxiosResponse): Promise<ProducerViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProducerViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProducerViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProducerViewModel[]>(null as any);
    }
}

export class ProductClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getProductsByCarrierId(carrierId: number , cancelToken?: CancelToken | undefined): Promise<ProductViewModel[]> {
        let url_ = this.baseUrl + "/api/products/{carrierId}";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined.");
        url_ = url_.replace("{carrierId}", encodeURIComponent("" + carrierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsByCarrierId(_response);
        });
    }

    protected processGetProductsByCarrierId(response: AxiosResponse): Promise<ProductViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductViewModel[]>(null as any);
    }

    getProductDetailById(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ProductDetailViewModel> {
        let url_ = this.baseUrl + "/api/products/get-product-detail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductDetailById(_response);
        });
    }

    protected processGetProductDetailById(response: AxiosResponse): Promise<ProductDetailViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDetailViewModel.fromJS(resultData200);
            return Promise.resolve<ProductDetailViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDetailViewModel>(null as any);
    }
}

export class UsersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    testEmail(userEmail: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/users/send-email?";
        if (userEmail !== undefined && userEmail !== null)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestEmail(_response);
        });
    }

    protected processTestEmail(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getUsers(isDeleted: boolean | undefined, emailAddress: string | null | undefined, isActive: boolean | null | undefined, role: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfUserViewModel> {
        let url_ = this.baseUrl + "/api/users?";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (role !== undefined && role !== null)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<QueryResultsOfUserViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfUserViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfUserViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfUserViewModel>(null as any);
    }

    getUsersAdmins(isDeleted: boolean | undefined, emailAddress: string | null | undefined, isActive: boolean | null | undefined, role: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserViewModel[]> {
        let url_ = this.baseUrl + "/api/users/get-user?";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (role !== undefined && role !== null)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersAdmins(_response);
        });
    }

    protected processGetUsersAdmins(response: AxiosResponse): Promise<UserViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserViewModel[]>(null as any);
    }

    getPlanContributions(userId: string | null, time: number | undefined , cancelToken?: CancelToken | undefined): Promise<PlanContributionViewModel> {
        let url_ = this.baseUrl + "/api/users/{userId}/plan-contributions?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (time === null)
            throw new Error("The parameter 'time' cannot be null.");
        else if (time !== undefined)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlanContributions(_response);
        });
    }

    protected processGetPlanContributions(response: AxiosResponse): Promise<PlanContributionViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlanContributionViewModel.fromJS(resultData200);
            return Promise.resolve<PlanContributionViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlanContributionViewModel>(null as any);
    }

    getClientPlanContributions(userId: string | null, time: number | undefined, clientId: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<PlanContributionViewModel> {
        let url_ = this.baseUrl + "/api/users/{userId}/client-plan-contributions?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (time === null)
            throw new Error("The parameter 'time' cannot be null.");
        else if (time !== undefined)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientPlanContributions(_response);
        });
    }

    protected processGetClientPlanContributions(response: AxiosResponse): Promise<PlanContributionViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlanContributionViewModel.fromJS(resultData200);
            return Promise.resolve<PlanContributionViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlanContributionViewModel>(null as any);
    }

    getDocumentsCount(userId: string | null, divisionId: number | undefined , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/users/{userId}/documents-count?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (divisionId === null)
            throw new Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentsCount(_response);
        });
    }

    protected processGetDocumentsCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getPlantHistories(time: number | undefined, policiesId: number[] | null | undefined, contributionType: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<PlanContributionsHistory[]> {
        let url_ = this.baseUrl + "/api/users/plant-history?";
        if (time === null)
            throw new Error("The parameter 'time' cannot be null.");
        else if (time !== undefined)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        if (policiesId !== undefined && policiesId !== null)
            policiesId && policiesId.forEach(item => { url_ += "policiesId=" + encodeURIComponent("" + item) + "&"; });
        if (contributionType !== undefined && contributionType !== null)
            url_ += "contributionType=" + encodeURIComponent("" + contributionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlantHistories(_response);
        });
    }

    protected processGetPlantHistories(response: AxiosResponse): Promise<PlanContributionsHistory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanContributionsHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PlanContributionsHistory[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlanContributionsHistory[]>(null as any);
    }

    savePlantHistory(planContributionHistoryRequest: PlanContributionHistoryRequest , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/users/plant-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(planContributionHistoryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSavePlantHistory(_response);
        });
    }

    protected processSavePlantHistory(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    plantHistoryDownloadCSV(time: number | undefined, policyIds: number[] | null | undefined, contributionType: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/users/plant-history/csv?";
        if (time === null)
            throw new Error("The parameter 'time' cannot be null.");
        else if (time !== undefined)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        if (policyIds !== undefined && policyIds !== null)
            policyIds && policyIds.forEach(item => { url_ += "policyIds=" + encodeURIComponent("" + item) + "&"; });
        if (contributionType !== undefined && contributionType !== null)
            url_ += "contributionType=" + encodeURIComponent("" + contributionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlantHistoryDownloadCSV(_response);
        });
    }

    protected processPlantHistoryDownloadCSV(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAccummulatedHistories(time: number | undefined, policiesId: number[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<AccumulatedValuesHistory[]> {
        let url_ = this.baseUrl + "/api/users/accummulated-history?";
        if (time === null)
            throw new Error("The parameter 'time' cannot be null.");
        else if (time !== undefined)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        if (policiesId !== undefined && policiesId !== null)
            policiesId && policiesId.forEach(item => { url_ += "policiesId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccummulatedHistories(_response);
        });
    }

    protected processGetAccummulatedHistories(response: AxiosResponse): Promise<AccumulatedValuesHistory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccumulatedValuesHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccumulatedValuesHistory[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccumulatedValuesHistory[]>(null as any);
    }

    saveAccummulatedHistory(request: AccumulatedValuesHistoryRequest , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/users/accummulated-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAccummulatedHistory(_response);
        });
    }

    protected processSaveAccummulatedHistory(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    accummulatedHistoriesDownloadCSV(time: number | undefined, policiesId: number[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/users/accummulated-history/csv?";
        if (time === null)
            throw new Error("The parameter 'time' cannot be null.");
        else if (time !== undefined)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        if (policiesId !== undefined && policiesId !== null)
            policiesId && policiesId.forEach(item => { url_ += "policiesId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccummulatedHistoriesDownloadCSV(_response);
        });
    }

    protected processAccummulatedHistoriesDownloadCSV(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getUserById(userId: string | null, includePolicy: boolean | undefined, includePolicyData: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/users/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (includePolicy === null)
            throw new Error("The parameter 'includePolicy' cannot be null.");
        else if (includePolicy !== undefined)
            url_ += "IncludePolicy=" + encodeURIComponent("" + includePolicy) + "&";
        if (includePolicyData === null)
            throw new Error("The parameter 'includePolicyData' cannot be null.");
        else if (includePolicyData !== undefined)
            url_ += "IncludePolicyData=" + encodeURIComponent("" + includePolicyData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: AxiosResponse): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserViewModel.fromJS(resultData200);
            return Promise.resolve<UserViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    resendConfirmationEmail(userId: string | null , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendConfirmationEmail(_response);
        });
    }

    protected processResendConfirmationEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    softDelete(userId: string | null , cancelToken?: CancelToken | undefined): Promise<DeletedUserViewModel> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSoftDelete(_response);
        });
    }

    protected processSoftDelete(response: AxiosResponse): Promise<DeletedUserViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeletedUserViewModel.fromJS(resultData200);
            return Promise.resolve<DeletedUserViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeletedUserViewModel>(null as any);
    }

    createEmailChangeRequest(request: ChangeEmailRequest , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/users/request-email-change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEmailChangeRequest(_response);
        });
    }

    protected processCreateEmailChangeRequest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    cancelEmailChangeRequest(email: string | null | undefined, token: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/users/cancel-email-change?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelEmailChangeRequest(_response);
        });
    }

    protected processCancelEmailChangeRequest(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    confirmChangeEmailRequest(email: string | null | undefined, token: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/users/confirm-email-change?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmChangeEmailRequest(_response);
        });
    }

    protected processConfirmChangeEmailRequest(response: AxiosResponse): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserViewModel.fromJS(resultData200);
            return Promise.resolve<UserViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    validateUserEmail(request: ValidateUserEmailRequest , cancelToken?: CancelToken | undefined): Promise<UserEmailValidationResult> {
        let url_ = this.baseUrl + "/api/users/validate-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateUserEmail(_response);
        });
    }

    protected processValidateUserEmail(response: AxiosResponse): Promise<UserEmailValidationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserEmailValidationResult.fromJS(resultData200);
            return Promise.resolve<UserEmailValidationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserEmailValidationResult>(null as any);
    }

    unarchiveUser(request: UnarchiveUserRequest , cancelToken?: CancelToken | undefined): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/users/unarchive-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnarchiveUser(_response);
        });
    }

    protected processUnarchiveUser(response: AxiosResponse): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserViewModel.fromJS(resultData200);
            return Promise.resolve<UserViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    saveUser(request: UserRequest , cancelToken?: CancelToken | undefined): Promise<UserViewModelWithChanges> {
        let url_ = this.baseUrl + "/api/users/save-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveUser(_response);
        });
    }

    protected processSaveUser(response: AxiosResponse): Promise<UserViewModelWithChanges> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserViewModelWithChanges.fromJS(resultData200);
            return Promise.resolve<UserViewModelWithChanges>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserViewModelWithChanges>(null as any);
    }

    toggleUser(userId: string | null, request: ToggleUserRequest , cancelToken?: CancelToken | undefined): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/users/{userId}/toggle";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleUser(_response);
        });
    }

    protected processToggleUser(response: AxiosResponse): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserViewModel.fromJS(resultData200);
            return Promise.resolve<UserViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    validateConfirmationToken(userId: string | null, request: ValidateTokenRequest , cancelToken?: CancelToken | undefined): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/users/{userId}/validate-token";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateConfirmationToken(_response);
        });
    }

    protected processValidateConfirmationToken(response: AxiosResponse): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserViewModel.fromJS(resultData200);
            return Promise.resolve<UserViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    setNewPassword(request: SetNewPasswordRequest , cancelToken?: CancelToken | undefined): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/users/set-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetNewPassword(_response);
        });
    }

    protected processSetNewPassword(response: AxiosResponse): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserViewModel.fromJS(resultData200);
            return Promise.resolve<UserViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    forgotPassword(request: ForgotPasswordRequest , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/users/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    sendChangesAlert(model: ChangesAlertRequest , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/users/send-changes-alert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendChangesAlert(_response);
        });
    }

    protected processSendChangesAlert(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class AfrRateViewModel implements IAfrRateViewModel {
    id!: number;
    year!: number;
    rates?: MonthOfYear | undefined;

    constructor(data?: IAfrRateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.rates = _data["rates"] ? MonthOfYear.fromJS(_data["rates"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AfrRateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AfrRateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["rates"] = this.rates ? this.rates.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAfrRateViewModel {
    id: number;
    year: number;
    rates?: MonthOfYear | undefined;
}

export class MonthOfYear implements IMonthOfYear {
    jan!: number;
    feb!: number;
    mar!: number;
    apr!: number;
    may!: number;
    jun!: number;
    jul!: number;
    aug!: number;
    sep!: number;
    oct!: number;
    nov!: number;
    dec!: number;

    constructor(data?: IMonthOfYear) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jan = _data["jan"];
            this.feb = _data["feb"];
            this.mar = _data["mar"];
            this.apr = _data["apr"];
            this.may = _data["may"];
            this.jun = _data["jun"];
            this.jul = _data["jul"];
            this.aug = _data["aug"];
            this.sep = _data["sep"];
            this.oct = _data["oct"];
            this.nov = _data["nov"];
            this.dec = _data["dec"];
        }
    }

    static fromJS(data: any): MonthOfYear {
        data = typeof data === 'object' ? data : {};
        let result = new MonthOfYear();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jan"] = this.jan;
        data["feb"] = this.feb;
        data["mar"] = this.mar;
        data["apr"] = this.apr;
        data["may"] = this.may;
        data["jun"] = this.jun;
        data["jul"] = this.jul;
        data["aug"] = this.aug;
        data["sep"] = this.sep;
        data["oct"] = this.oct;
        data["nov"] = this.nov;
        data["dec"] = this.dec;
        return data;
    }
}

export interface IMonthOfYear {
    jan: number;
    feb: number;
    mar: number;
    apr: number;
    may: number;
    jun: number;
    jul: number;
    aug: number;
    sep: number;
    oct: number;
    nov: number;
    dec: number;
}

export class BasicClientViewModel implements IBasicClientViewModel {
    id!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IBasicClientViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): BasicClientViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BasicClientViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface IBasicClientViewModel {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export class ClientViewModel extends BasicClientViewModel implements IClientViewModel {
    userName?: string | undefined;
    userId?: string | undefined;
    phoneNumber?: string | undefined;
    isActive!: boolean;
    statusType!: StatusType;
    statusAppliedAsOf?: string | undefined;
    startDate?: string | undefined;
    dateOfBirth?: string | undefined;
    clientUniqueId?: string | undefined;
    note?: string | undefined;
    title!: number;
    divisionId!: number;
    planEnrollmentDate?: string | undefined;
    matchingContribution!: boolean;
    percentage!: number;
    divisionName?: string | undefined;
    employerName?: string | undefined;
    planName?: string | undefined;
    address?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IClientViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.statusType = _data["statusType"];
            this.statusAppliedAsOf = _data["statusAppliedAsOf"];
            this.startDate = _data["startDate"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.clientUniqueId = _data["clientUniqueId"];
            this.note = _data["note"];
            this.title = _data["title"];
            this.divisionId = _data["divisionId"];
            this.planEnrollmentDate = _data["planEnrollmentDate"];
            this.matchingContribution = _data["matchingContribution"];
            this.percentage = _data["percentage"];
            this.divisionName = _data["divisionName"];
            this.employerName = _data["employerName"];
            this.planName = _data["planName"];
            this.address = _data["address"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): ClientViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["statusType"] = this.statusType;
        data["statusAppliedAsOf"] = this.statusAppliedAsOf;
        data["startDate"] = this.startDate;
        data["dateOfBirth"] = this.dateOfBirth;
        data["clientUniqueId"] = this.clientUniqueId;
        data["note"] = this.note;
        data["title"] = this.title;
        data["divisionId"] = this.divisionId;
        data["planEnrollmentDate"] = this.planEnrollmentDate;
        data["matchingContribution"] = this.matchingContribution;
        data["percentage"] = this.percentage;
        data["divisionName"] = this.divisionName;
        data["employerName"] = this.employerName;
        data["planName"] = this.planName;
        data["address"] = this.address;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zip"] = this.zip;
        super.toJSON(data);
        return data;
    }
}

export interface IClientViewModel extends IBasicClientViewModel {
    userName?: string | undefined;
    userId?: string | undefined;
    phoneNumber?: string | undefined;
    isActive: boolean;
    statusType: StatusType;
    statusAppliedAsOf?: string | undefined;
    startDate?: string | undefined;
    dateOfBirth?: string | undefined;
    clientUniqueId?: string | undefined;
    note?: string | undefined;
    title: number;
    divisionId: number;
    planEnrollmentDate?: string | undefined;
    matchingContribution: boolean;
    percentage: number;
    divisionName?: string | undefined;
    employerName?: string | undefined;
    planName?: string | undefined;
    address?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
}

export enum StatusType {
    ActiveContributing = "ActiveContributing",
    ActiveNonContributing = "ActiveNonContributing",
    NonParticipating = "NonParticipating",
    TerminatedDeferredBenefit = "TerminatedDeferredBenefit",
    TerminatedReceivingBenefit = "TerminatedReceivingBenefit",
    TerminatedExhaustedBenefit = "TerminatedExhaustedBenefit",
    RetiredDeferredBenefit = "RetiredDeferredBenefit",
    RetiredReceivingBenefit = "RetiredReceivingBenefit",
    RetiredExhaustedBenefit = "RetiredExhaustedBenefit",
    Deceased = "Deceased",
    Active = "Active",
    InActive = "InActive",
}

export class ReceivableDetailViewModel implements IReceivableDetailViewModel {
    participantId!: number;
    participant?: string | undefined;
    receivableAsStart!: number;
    cummulativePreniumPaidInPeriod!: number;
    interestAccuredInPeriod!: number;
    totalReceivableAccruedInPeriod!: number;
    receivableAsEnd!: number;
    netAccumulatedValue!: number;
    cashSurrenderValue!: number;

    constructor(data?: IReceivableDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.participant = _data["participant"];
            this.receivableAsStart = _data["receivableAsStart"];
            this.cummulativePreniumPaidInPeriod = _data["cummulativePreniumPaidInPeriod"];
            this.interestAccuredInPeriod = _data["interestAccuredInPeriod"];
            this.totalReceivableAccruedInPeriod = _data["totalReceivableAccruedInPeriod"];
            this.receivableAsEnd = _data["receivableAsEnd"];
            this.netAccumulatedValue = _data["netAccumulatedValue"];
            this.cashSurrenderValue = _data["cashSurrenderValue"];
        }
    }

    static fromJS(data: any): ReceivableDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReceivableDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["participant"] = this.participant;
        data["receivableAsStart"] = this.receivableAsStart;
        data["cummulativePreniumPaidInPeriod"] = this.cummulativePreniumPaidInPeriod;
        data["interestAccuredInPeriod"] = this.interestAccuredInPeriod;
        data["totalReceivableAccruedInPeriod"] = this.totalReceivableAccruedInPeriod;
        data["receivableAsEnd"] = this.receivableAsEnd;
        data["netAccumulatedValue"] = this.netAccumulatedValue;
        data["cashSurrenderValue"] = this.cashSurrenderValue;
        return data;
    }
}

export interface IReceivableDetailViewModel {
    participantId: number;
    participant?: string | undefined;
    receivableAsStart: number;
    cummulativePreniumPaidInPeriod: number;
    interestAccuredInPeriod: number;
    totalReceivableAccruedInPeriod: number;
    receivableAsEnd: number;
    netAccumulatedValue: number;
    cashSurrenderValue: number;
}

export class AccountsRequest implements IAccountsRequest {
    division?: UserDivisionRequest | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    includeNetAccumulatedValue!: boolean;
    includeCashSurrenderValue!: boolean;

    constructor(data?: IAccountsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.division = _data["division"] ? UserDivisionRequest.fromJS(_data["division"]) : <any>undefined;
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.includeNetAccumulatedValue = _data["includeNetAccumulatedValue"];
            this.includeCashSurrenderValue = _data["includeCashSurrenderValue"];
        }
    }

    static fromJS(data: any): AccountsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division ? this.division.toJSON() : <any>undefined;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["includeNetAccumulatedValue"] = this.includeNetAccumulatedValue;
        data["includeCashSurrenderValue"] = this.includeCashSurrenderValue;
        return data;
    }
}

export interface IAccountsRequest {
    division?: UserDivisionRequest | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    includeNetAccumulatedValue: boolean;
    includeCashSurrenderValue: boolean;
}

export class UserDivisionRequest implements IUserDivisionRequest {
    id!: number;
    name?: string | undefined;
    employerId!: number;
    employerName?: string | undefined;

    constructor(data?: IUserDivisionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.employerId = _data["employerId"];
            this.employerName = _data["employerName"];
        }
    }

    static fromJS(data: any): UserDivisionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserDivisionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["employerId"] = this.employerId;
        data["employerName"] = this.employerName;
        return data;
    }
}

export interface IUserDivisionRequest {
    id: number;
    name?: string | undefined;
    employerId: number;
    employerName?: string | undefined;
}

export class ReceiavbleCalculateViewModel implements IReceiavbleCalculateViewModel {
    year!: number;
    employerName?: string | undefined;
    divisionName?: string | undefined;
    rates?: MonthOfYear | undefined;
    interestValue?: InterestAccrued[] | undefined;

    constructor(data?: IReceiavbleCalculateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.employerName = _data["employerName"];
            this.divisionName = _data["divisionName"];
            this.rates = _data["rates"] ? MonthOfYear.fromJS(_data["rates"]) : <any>undefined;
            if (Array.isArray(_data["interestValue"])) {
                this.interestValue = [] as any;
                for (let item of _data["interestValue"])
                    this.interestValue!.push(InterestAccrued.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReceiavbleCalculateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiavbleCalculateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["employerName"] = this.employerName;
        data["divisionName"] = this.divisionName;
        data["rates"] = this.rates ? this.rates.toJSON() : <any>undefined;
        if (Array.isArray(this.interestValue)) {
            data["interestValue"] = [];
            for (let item of this.interestValue)
                data["interestValue"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReceiavbleCalculateViewModel {
    year: number;
    employerName?: string | undefined;
    divisionName?: string | undefined;
    rates?: MonthOfYear | undefined;
    interestValue?: InterestAccrued[] | undefined;
}

export class InterestAccrued implements IInterestAccrued {
    month!: number;
    year!: number;
    clientId!: number;
    clientName?: string | undefined;
    totalPreniumValue!: number;
    policyId!: number;
    preniumAmount!: number;
    receivableAccuredValues?: ReceivableAccured[] | undefined;

    constructor(data?: IInterestAccrued) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.totalPreniumValue = _data["totalPreniumValue"];
            this.policyId = _data["policyId"];
            this.preniumAmount = _data["preniumAmount"];
            if (Array.isArray(_data["receivableAccuredValues"])) {
                this.receivableAccuredValues = [] as any;
                for (let item of _data["receivableAccuredValues"])
                    this.receivableAccuredValues!.push(ReceivableAccured.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InterestAccrued {
        data = typeof data === 'object' ? data : {};
        let result = new InterestAccrued();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["totalPreniumValue"] = this.totalPreniumValue;
        data["policyId"] = this.policyId;
        data["preniumAmount"] = this.preniumAmount;
        if (Array.isArray(this.receivableAccuredValues)) {
            data["receivableAccuredValues"] = [];
            for (let item of this.receivableAccuredValues)
                data["receivableAccuredValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInterestAccrued {
    month: number;
    year: number;
    clientId: number;
    clientName?: string | undefined;
    totalPreniumValue: number;
    policyId: number;
    preniumAmount: number;
    receivableAccuredValues?: ReceivableAccured[] | undefined;
}

export class ReceivableAccured implements IReceivableAccured {
    participantId!: number;
    minRate!: number;
    receivableYear!: number;
    valueOnJan!: number;
    valueOnFeb!: number;
    valueOnMar!: number;
    valueOnApr!: number;
    valueOnMay!: number;
    valueOnJun!: number;
    valueOnJul!: number;
    valueOnAug!: number;
    valueOnSep!: number;
    valueOnOct!: number;
    valueOnNov!: number;
    valueOnDec!: number;

    constructor(data?: IReceivableAccured) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.minRate = _data["minRate"];
            this.receivableYear = _data["receivableYear"];
            this.valueOnJan = _data["valueOnJan"];
            this.valueOnFeb = _data["valueOnFeb"];
            this.valueOnMar = _data["valueOnMar"];
            this.valueOnApr = _data["valueOnApr"];
            this.valueOnMay = _data["valueOnMay"];
            this.valueOnJun = _data["valueOnJun"];
            this.valueOnJul = _data["valueOnJul"];
            this.valueOnAug = _data["valueOnAug"];
            this.valueOnSep = _data["valueOnSep"];
            this.valueOnOct = _data["valueOnOct"];
            this.valueOnNov = _data["valueOnNov"];
            this.valueOnDec = _data["valueOnDec"];
        }
    }

    static fromJS(data: any): ReceivableAccured {
        data = typeof data === 'object' ? data : {};
        let result = new ReceivableAccured();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["minRate"] = this.minRate;
        data["receivableYear"] = this.receivableYear;
        data["valueOnJan"] = this.valueOnJan;
        data["valueOnFeb"] = this.valueOnFeb;
        data["valueOnMar"] = this.valueOnMar;
        data["valueOnApr"] = this.valueOnApr;
        data["valueOnMay"] = this.valueOnMay;
        data["valueOnJun"] = this.valueOnJun;
        data["valueOnJul"] = this.valueOnJul;
        data["valueOnAug"] = this.valueOnAug;
        data["valueOnSep"] = this.valueOnSep;
        data["valueOnOct"] = this.valueOnOct;
        data["valueOnNov"] = this.valueOnNov;
        data["valueOnDec"] = this.valueOnDec;
        return data;
    }
}

export interface IReceivableAccured {
    participantId: number;
    minRate: number;
    receivableYear: number;
    valueOnJan: number;
    valueOnFeb: number;
    valueOnMar: number;
    valueOnApr: number;
    valueOnMay: number;
    valueOnJun: number;
    valueOnJul: number;
    valueOnAug: number;
    valueOnSep: number;
    valueOnOct: number;
    valueOnNov: number;
    valueOnDec: number;
}

export class ParticipantRequest implements IParticipantRequest {
    participantId!: number;
    year!: number;

    constructor(data?: IParticipantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): ParticipantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["year"] = this.year;
        return data;
    }
}

export interface IParticipantRequest {
    participantId: number;
    year: number;
}

export class ReceivableDownloadRequest implements IReceivableDownloadRequest {
    receivables?: ReceivableDetailViewModel[] | undefined;
    employerName?: string | undefined;
    divisionName?: string | undefined;
    startAt?: string | undefined;
    endAt?: string | undefined;
    includeNetAccumulatedValue!: boolean;
    includeCashSurrenderValue!: boolean;

    constructor(data?: IReceivableDownloadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["receivables"])) {
                this.receivables = [] as any;
                for (let item of _data["receivables"])
                    this.receivables!.push(ReceivableDetailViewModel.fromJS(item));
            }
            this.employerName = _data["employerName"];
            this.divisionName = _data["divisionName"];
            this.startAt = _data["startAt"];
            this.endAt = _data["endAt"];
            this.includeNetAccumulatedValue = _data["includeNetAccumulatedValue"];
            this.includeCashSurrenderValue = _data["includeCashSurrenderValue"];
        }
    }

    static fromJS(data: any): ReceivableDownloadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReceivableDownloadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.receivables)) {
            data["receivables"] = [];
            for (let item of this.receivables)
                data["receivables"].push(item.toJSON());
        }
        data["employerName"] = this.employerName;
        data["divisionName"] = this.divisionName;
        data["startAt"] = this.startAt;
        data["endAt"] = this.endAt;
        data["includeNetAccumulatedValue"] = this.includeNetAccumulatedValue;
        data["includeCashSurrenderValue"] = this.includeCashSurrenderValue;
        return data;
    }
}

export interface IReceivableDownloadRequest {
    receivables?: ReceivableDetailViewModel[] | undefined;
    employerName?: string | undefined;
    divisionName?: string | undefined;
    startAt?: string | undefined;
    endAt?: string | undefined;
    includeNetAccumulatedValue: boolean;
    includeCashSurrenderValue: boolean;
}

export class AppInfo implements IAppInfo {
    companyName?: string | undefined;
    copyrightYear!: number;
    informationalVersion?: string | undefined;
    productName?: string | undefined;
    versionNumber?: string | undefined;
    versionNumberWithBuildNumber?: string | undefined;

    constructor(data?: IAppInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.copyrightYear = _data["copyrightYear"];
            this.informationalVersion = _data["informationalVersion"];
            this.productName = _data["productName"];
            this.versionNumber = _data["versionNumber"];
            this.versionNumberWithBuildNumber = _data["versionNumberWithBuildNumber"];
        }
    }

    static fromJS(data: any): AppInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AppInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["copyrightYear"] = this.copyrightYear;
        data["informationalVersion"] = this.informationalVersion;
        data["productName"] = this.productName;
        data["versionNumber"] = this.versionNumber;
        data["versionNumberWithBuildNumber"] = this.versionNumberWithBuildNumber;
        return data;
    }
}

export interface IAppInfo {
    companyName?: string | undefined;
    copyrightYear: number;
    informationalVersion?: string | undefined;
    productName?: string | undefined;
    versionNumber?: string | undefined;
    versionNumberWithBuildNumber?: string | undefined;
}

export class KeystoneModels implements IKeystoneModels {
    carrierQuery?: CarrierQuery | undefined;
    employerQuery?: EmployerQuery | undefined;
    userListArgs?: UserQuery | undefined;

    constructor(data?: IKeystoneModels) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierQuery = _data["carrierQuery"] ? CarrierQuery.fromJS(_data["carrierQuery"]) : <any>undefined;
            this.employerQuery = _data["employerQuery"] ? EmployerQuery.fromJS(_data["employerQuery"]) : <any>undefined;
            this.userListArgs = _data["userListArgs"] ? UserQuery.fromJS(_data["userListArgs"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KeystoneModels {
        data = typeof data === 'object' ? data : {};
        let result = new KeystoneModels();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierQuery"] = this.carrierQuery ? this.carrierQuery.toJSON() : <any>undefined;
        data["employerQuery"] = this.employerQuery ? this.employerQuery.toJSON() : <any>undefined;
        data["userListArgs"] = this.userListArgs ? this.userListArgs.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKeystoneModels {
    carrierQuery?: CarrierQuery | undefined;
    employerQuery?: EmployerQuery | undefined;
    userListArgs?: UserQuery | undefined;
}

export class Query implements IQuery {
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize!: number;
    pageNumber!: number;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["sortCriteria"])) {
                this.sortCriteria = [] as any;
                for (let item of _data["sortCriteria"])
                    this.sortCriteria!.push(SortCriterion.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        if (Array.isArray(this.sortCriteria)) {
            data["sortCriteria"] = [];
            for (let item of this.sortCriteria)
                data["sortCriteria"].push(item.toJSON());
        }
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IQuery {
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize: number;
    pageNumber: number;
}

export class CarrierQuery extends Query implements ICarrierQuery {

    constructor(data?: ICarrierQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CarrierQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICarrierQuery extends IQuery {
}

export class SortCriterion implements ISortCriterion {
    sortKey?: string | undefined;
    isDescending!: boolean;

    constructor(data?: ISortCriterion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortKey = _data["sortKey"];
            this.isDescending = _data["isDescending"];
        }
    }

    static fromJS(data: any): SortCriterion {
        data = typeof data === 'object' ? data : {};
        let result = new SortCriterion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortKey"] = this.sortKey;
        data["isDescending"] = this.isDescending;
        return data;
    }
}

export interface ISortCriterion {
    sortKey?: string | undefined;
    isDescending: boolean;
}

export class EmployerQuery extends Query implements IEmployerQuery {

    constructor(data?: IEmployerQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EmployerQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEmployerQuery extends IQuery {
}

export class UserQuery2 extends Query implements IUserQuery2 {
    emailAddress?: string | undefined;
    isActive?: boolean | undefined;
    role?: string | undefined;

    constructor(data?: IUserQuery2) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UserQuery2 {
        data = typeof data === 'object' ? data : {};
        let result = new UserQuery2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["role"] = this.role;
        super.toJSON(data);
        return data;
    }
}

export interface IUserQuery2 extends IQuery {
    emailAddress?: string | undefined;
    isActive?: boolean | undefined;
    role?: string | undefined;
}

export class UserQuery extends UserQuery2 implements IUserQuery {
    isDeleted!: boolean;

    constructor(data?: IUserQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): UserQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        super.toJSON(data);
        return data;
    }
}

export interface IUserQuery extends IUserQuery2 {
    isDeleted: boolean;
}

export class LoginResponse implements ILoginResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    user?: ApplicationUserResponse | undefined;

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.user = _data["user"] ? ApplicationUserResponse.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoginResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    user?: ApplicationUserResponse | undefined;
}

export class ApplicationUserResponse implements IApplicationUserResponse {
    id?: string | undefined;
    producerId?: number | undefined;
    employerAdminId?: number | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    employers?: EmployerViewModel[] | undefined;
    divisions?: DivisionViewModel[] | undefined;
    clients?: ClientViewModel[] | undefined;

    constructor(data?: IApplicationUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.producerId = _data["producerId"];
            this.employerAdminId = _data["employerAdminId"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.role = _data["role"];
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(EmployerViewModel.fromJS(item));
            }
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(DivisionViewModel.fromJS(item));
            }
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(ClientViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["producerId"] = this.producerId;
        data["employerAdminId"] = this.employerAdminId;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["role"] = this.role;
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item.toJSON());
        }
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApplicationUserResponse {
    id?: string | undefined;
    producerId?: number | undefined;
    employerAdminId?: number | undefined;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    employers?: EmployerViewModel[] | undefined;
    divisions?: DivisionViewModel[] | undefined;
    clients?: ClientViewModel[] | undefined;
}

export class EmployerViewModel implements IEmployerViewModel {
    id!: number;
    name?: string | undefined;
    isActive!: boolean;

    constructor(data?: IEmployerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EmployerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IEmployerViewModel {
    id: number;
    name?: string | undefined;
    isActive: boolean;
}

export class DivisionViewModel implements IDivisionViewModel {
    id!: number;
    name?: string | undefined;
    employerId!: number;
    employerName?: string | undefined;
    address?: string | undefined;
    planName?: string | undefined;
    matchingContribution!: boolean;
    percentage!: number;
    employer?: EmployerViewModel | undefined;
    producers?: ProducerViewModel[] | undefined;
    employerAdmins?: EmployerAdminViewModel[] | undefined;

    constructor(data?: IDivisionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.employerId = _data["employerId"];
            this.employerName = _data["employerName"];
            this.address = _data["address"];
            this.planName = _data["planName"];
            this.matchingContribution = _data["matchingContribution"];
            this.percentage = _data["percentage"];
            this.employer = _data["employer"] ? EmployerViewModel.fromJS(_data["employer"]) : <any>undefined;
            if (Array.isArray(_data["producers"])) {
                this.producers = [] as any;
                for (let item of _data["producers"])
                    this.producers!.push(ProducerViewModel.fromJS(item));
            }
            if (Array.isArray(_data["employerAdmins"])) {
                this.employerAdmins = [] as any;
                for (let item of _data["employerAdmins"])
                    this.employerAdmins!.push(EmployerAdminViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DivisionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["employerId"] = this.employerId;
        data["employerName"] = this.employerName;
        data["address"] = this.address;
        data["planName"] = this.planName;
        data["matchingContribution"] = this.matchingContribution;
        data["percentage"] = this.percentage;
        data["employer"] = this.employer ? this.employer.toJSON() : <any>undefined;
        if (Array.isArray(this.producers)) {
            data["producers"] = [];
            for (let item of this.producers)
                data["producers"].push(item.toJSON());
        }
        if (Array.isArray(this.employerAdmins)) {
            data["employerAdmins"] = [];
            for (let item of this.employerAdmins)
                data["employerAdmins"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDivisionViewModel {
    id: number;
    name?: string | undefined;
    employerId: number;
    employerName?: string | undefined;
    address?: string | undefined;
    planName?: string | undefined;
    matchingContribution: boolean;
    percentage: number;
    employer?: EmployerViewModel | undefined;
    producers?: ProducerViewModel[] | undefined;
    employerAdmins?: EmployerAdminViewModel[] | undefined;
}

export class ProducerViewModel implements IProducerViewModel {
    name?: string | undefined;
    email?: string | undefined;
    userId?: string | undefined;
    since?: string | undefined;
    id!: number;

    constructor(data?: IProducerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.userId = _data["userId"];
            this.since = _data["since"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProducerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProducerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["userId"] = this.userId;
        data["since"] = this.since;
        data["id"] = this.id;
        return data;
    }
}

export interface IProducerViewModel {
    name?: string | undefined;
    email?: string | undefined;
    userId?: string | undefined;
    since?: string | undefined;
    id: number;
}

export class EmployerAdminViewModel implements IEmployerAdminViewModel {
    id!: number;
    email?: string | undefined;
    userId?: string | undefined;

    constructor(data?: IEmployerAdminViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): EmployerAdminViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerAdminViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IEmployerAdminViewModel {
    id: number;
    email?: string | undefined;
    userId?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export class LoginRequest implements ILoginRequest {
    email!: string;
    password!: string;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginRequest {
    email: string;
    password: string;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
}

export class QueryResultsOfCarrierViewModel implements IQueryResultsOfCarrierViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: CarrierViewModel[] | undefined;

    constructor(data?: IQueryResultsOfCarrierViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CarrierViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfCarrierViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfCarrierViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfCarrierViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: CarrierViewModel[] | undefined;
}

export class CarrierViewModel implements ICarrierViewModel {
    id!: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    isActive!: boolean;

    constructor(data?: ICarrierViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CarrierViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["city"] = this.city;
        data["state"] = this.state;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICarrierViewModel {
    id: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    isActive: boolean;
}

export class CarrierDetailViewModel implements ICarrierDetailViewModel {
    id!: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zipCode?: string | undefined;
    documentUrl?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    routing?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    notes?: string | undefined;
    isActive!: boolean;
    contacts?: CarrierContactViewModel[] | undefined;
    investments?: InvestmentViewModel[] | undefined;
    products?: ProductViewModel[] | undefined;

    constructor(data?: ICarrierDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.zipCode = _data["zipCode"];
            this.documentUrl = _data["documentUrl"];
            this.bankName = _data["bankName"];
            this.bankAddress = _data["bankAddress"];
            this.routing = _data["routing"];
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.notes = _data["notes"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(CarrierContactViewModel.fromJS(item));
            }
            if (Array.isArray(_data["investments"])) {
                this.investments = [] as any;
                for (let item of _data["investments"])
                    this.investments!.push(InvestmentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CarrierDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["city"] = this.city;
        data["state"] = this.state;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["zipCode"] = this.zipCode;
        data["documentUrl"] = this.documentUrl;
        data["bankName"] = this.bankName;
        data["bankAddress"] = this.bankAddress;
        data["routing"] = this.routing;
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["notes"] = this.notes;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.investments)) {
            data["investments"] = [];
            for (let item of this.investments)
                data["investments"].push(item.toJSON());
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICarrierDetailViewModel {
    id: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zipCode?: string | undefined;
    documentUrl?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    routing?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    notes?: string | undefined;
    isActive: boolean;
    contacts?: CarrierContactViewModel[] | undefined;
    investments?: InvestmentViewModel[] | undefined;
    products?: ProductViewModel[] | undefined;
}

export class CarrierContactViewModel implements ICarrierContactViewModel {
    id!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICarrierContactViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.position = _data["position"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CarrierContactViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierContactViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["position"] = this.position;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface ICarrierContactViewModel {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class InvestmentViewModel implements IInvestmentViewModel {
    id!: number;
    investmentName?: string | undefined;
    type?: string | undefined;
    carrierId!: number;
    percentage!: number;

    constructor(data?: IInvestmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.investmentName = _data["investmentName"];
            this.type = _data["type"];
            this.carrierId = _data["carrierId"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): InvestmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["investmentName"] = this.investmentName;
        data["type"] = this.type;
        data["carrierId"] = this.carrierId;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IInvestmentViewModel {
    id: number;
    investmentName?: string | undefined;
    type?: string | undefined;
    carrierId: number;
    percentage: number;
}

export class ProductViewModel implements IProductViewModel {
    id!: number;
    productName?: string | undefined;
    carrierId!: number;

    constructor(data?: IProductViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.carrierId = _data["carrierId"];
        }
    }

    static fromJS(data: any): ProductViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["carrierId"] = this.carrierId;
        return data;
    }
}

export interface IProductViewModel {
    id: number;
    productName?: string | undefined;
    carrierId: number;
}

export class CarrierRequest implements ICarrierRequest {
    id!: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zipCode?: string | undefined;
    documentUrl?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    routing?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    notes?: string | undefined;
    contacts?: CarrierContactRequest[] | undefined;
    investments?: CarrierInvestmentRequest[] | undefined;
    products?: CarrierProductRequest[] | undefined;

    constructor(data?: ICarrierRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.zipCode = _data["zipCode"];
            this.documentUrl = _data["documentUrl"];
            this.bankName = _data["bankName"];
            this.bankAddress = _data["bankAddress"];
            this.routing = _data["routing"];
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(CarrierContactRequest.fromJS(item));
            }
            if (Array.isArray(_data["investments"])) {
                this.investments = [] as any;
                for (let item of _data["investments"])
                    this.investments!.push(CarrierInvestmentRequest.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CarrierProductRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CarrierRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["city"] = this.city;
        data["state"] = this.state;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["zipCode"] = this.zipCode;
        data["documentUrl"] = this.documentUrl;
        data["bankName"] = this.bankName;
        data["bankAddress"] = this.bankAddress;
        data["routing"] = this.routing;
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["notes"] = this.notes;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.investments)) {
            data["investments"] = [];
            for (let item of this.investments)
                data["investments"].push(item.toJSON());
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICarrierRequest {
    id: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zipCode?: string | undefined;
    documentUrl?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    routing?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    notes?: string | undefined;
    contacts?: CarrierContactRequest[] | undefined;
    investments?: CarrierInvestmentRequest[] | undefined;
    products?: CarrierProductRequest[] | undefined;
}

export class CarrierContactRequest implements ICarrierContactRequest {
    id!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICarrierContactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.position = _data["position"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CarrierContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["position"] = this.position;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface ICarrierContactRequest {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class CarrierInvestmentRequest implements ICarrierInvestmentRequest {
    id!: number;
    investmentName?: string | undefined;
    type?: string | undefined;

    constructor(data?: ICarrierInvestmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.investmentName = _data["investmentName"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CarrierInvestmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierInvestmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["investmentName"] = this.investmentName;
        data["type"] = this.type;
        return data;
    }
}

export interface ICarrierInvestmentRequest {
    id: number;
    investmentName?: string | undefined;
    type?: string | undefined;
}

export class CarrierProductRequest implements ICarrierProductRequest {
    id!: number;
    productName?: string | undefined;

    constructor(data?: ICarrierProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
        }
    }

    static fromJS(data: any): CarrierProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        return data;
    }
}

export interface ICarrierProductRequest {
    id: number;
    productName?: string | undefined;
}

export class CarrierResourceViewModel implements ICarrierResourceViewModel {
    carrierId!: number;
    carrierName?: string | undefined;
    documentUrl?: string | undefined;

    constructor(data?: ICarrierResourceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierId = _data["carrierId"];
            this.carrierName = _data["carrierName"];
            this.documentUrl = _data["documentUrl"];
        }
    }

    static fromJS(data: any): CarrierResourceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierResourceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierId"] = this.carrierId;
        data["carrierName"] = this.carrierName;
        data["documentUrl"] = this.documentUrl;
        return data;
    }
}

export interface ICarrierResourceViewModel {
    carrierId: number;
    carrierName?: string | undefined;
    documentUrl?: string | undefined;
}

export class QueryResultsOfClientViewModel implements IQueryResultsOfClientViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ClientViewModel[] | undefined;

    constructor(data?: IQueryResultsOfClientViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ClientViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfClientViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfClientViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfClientViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ClientViewModel[] | undefined;
}

export class CustomReportResultViewModel implements ICustomReportResultViewModel {
    items?: CustomReportResultItem[] | undefined;

    constructor(data?: ICustomReportResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomReportResultItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomReportResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomReportResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomReportResultViewModel {
    items?: CustomReportResultItem[] | undefined;
}

export class CustomReportResultItem implements ICustomReportResultItem {
    userId?: string | undefined;
    clientId!: number;
    policyId!: number;
    client?: ClientItem | undefined;
    policy?: PolicyItem | undefined;
    contribution?: Contribution | undefined;
    login?: Login | undefined;
    investments?: Investment[] | undefined;
    beneficiaries?: Beneficiary[] | undefined;

    constructor(data?: ICustomReportResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            this.policyId = _data["policyId"];
            this.client = _data["client"] ? ClientItem.fromJS(_data["client"]) : <any>undefined;
            this.policy = _data["policy"] ? PolicyItem.fromJS(_data["policy"]) : <any>undefined;
            this.contribution = _data["contribution"] ? Contribution.fromJS(_data["contribution"]) : <any>undefined;
            this.login = _data["login"] ? Login.fromJS(_data["login"]) : <any>undefined;
            if (Array.isArray(_data["investments"])) {
                this.investments = [] as any;
                for (let item of _data["investments"])
                    this.investments!.push(Investment.fromJS(item));
            }
            if (Array.isArray(_data["beneficiaries"])) {
                this.beneficiaries = [] as any;
                for (let item of _data["beneficiaries"])
                    this.beneficiaries!.push(Beneficiary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomReportResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomReportResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        data["policyId"] = this.policyId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["contribution"] = this.contribution ? this.contribution.toJSON() : <any>undefined;
        data["login"] = this.login ? this.login.toJSON() : <any>undefined;
        if (Array.isArray(this.investments)) {
            data["investments"] = [];
            for (let item of this.investments)
                data["investments"].push(item.toJSON());
        }
        if (Array.isArray(this.beneficiaries)) {
            data["beneficiaries"] = [];
            for (let item of this.beneficiaries)
                data["beneficiaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomReportResultItem {
    userId?: string | undefined;
    clientId: number;
    policyId: number;
    client?: ClientItem | undefined;
    policy?: PolicyItem | undefined;
    contribution?: Contribution | undefined;
    login?: Login | undefined;
    investments?: Investment[] | undefined;
    beneficiaries?: Beneficiary[] | undefined;
}

export class ClientItem implements IClientItem {
    id!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    statusType?: string | undefined;
    division?: string | undefined;
    organization?: string | undefined;
    dateOfBirth?: string | undefined;

    constructor(data?: IClientItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.statusType = _data["statusType"];
            this.division = _data["division"];
            this.organization = _data["organization"];
            this.dateOfBirth = _data["dateOfBirth"];
        }
    }

    static fromJS(data: any): ClientItem {
        data = typeof data === 'object' ? data : {};
        let result = new ClientItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["role"] = this.role;
        data["statusType"] = this.statusType;
        data["division"] = this.division;
        data["organization"] = this.organization;
        data["dateOfBirth"] = this.dateOfBirth;
        return data;
    }
}

export interface IClientItem {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    statusType?: string | undefined;
    division?: string | undefined;
    organization?: string | undefined;
    dateOfBirth?: string | undefined;
}

export class PolicyItem implements IPolicyItem {
    id!: number;
    clientId!: number;
    userId?: string | undefined;
    accountLabel!: AccountLabel;
    policyNumber?: string | undefined;
    anniversaryDate?: string | undefined;
    created!: string;
    modified!: string;
    status!: PolicyStatus;
    statusAppliedAsOf?: string | undefined;
    coInsured?: string | undefined;
    coInsuredBirthDay?: string | undefined;
    matchingContribution!: boolean;
    percentage!: number;
    productName?: string | undefined;

    constructor(data?: IPolicyItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.userId = _data["userId"];
            this.accountLabel = _data["accountLabel"];
            this.policyNumber = _data["policyNumber"];
            this.anniversaryDate = _data["anniversaryDate"];
            this.created = _data["created"];
            this.modified = _data["modified"];
            this.status = _data["status"];
            this.statusAppliedAsOf = _data["statusAppliedAsOf"];
            this.coInsured = _data["coInsured"];
            this.coInsuredBirthDay = _data["coInsuredBirthDay"];
            this.matchingContribution = _data["matchingContribution"];
            this.percentage = _data["percentage"];
            this.productName = _data["productName"];
        }
    }

    static fromJS(data: any): PolicyItem {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["userId"] = this.userId;
        data["accountLabel"] = this.accountLabel;
        data["policyNumber"] = this.policyNumber;
        data["anniversaryDate"] = this.anniversaryDate;
        data["created"] = this.created;
        data["modified"] = this.modified;
        data["status"] = this.status;
        data["statusAppliedAsOf"] = this.statusAppliedAsOf;
        data["coInsured"] = this.coInsured;
        data["coInsuredBirthDay"] = this.coInsuredBirthDay;
        data["matchingContribution"] = this.matchingContribution;
        data["percentage"] = this.percentage;
        data["productName"] = this.productName;
        return data;
    }
}

export interface IPolicyItem {
    id: number;
    clientId: number;
    userId?: string | undefined;
    accountLabel: AccountLabel;
    policyNumber?: string | undefined;
    anniversaryDate?: string | undefined;
    created: string;
    modified: string;
    status: PolicyStatus;
    statusAppliedAsOf?: string | undefined;
    coInsured?: string | undefined;
    coInsuredBirthDay?: string | undefined;
    matchingContribution: boolean;
    percentage: number;
    productName?: string | undefined;
}

export enum AccountLabel {
    Default = "Default",
    Recovery = "Recovery",
    Benefit = "Benefit",
}

export enum PolicyStatus {
    Active = "Active",
    Exchanged = "Exchanged",
    Lapsed = "Lapsed",
    Surrendered = "Surrendered",
    Matured = "Matured",
}

export class Contribution implements IContribution {
    loan!: number;
    accumulatedValue!: number;
    deathBenefit!: number;
    lastValuationDate?: string | undefined;

    constructor(data?: IContribution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loan = _data["loan"];
            this.accumulatedValue = _data["accumulatedValue"];
            this.deathBenefit = _data["deathBenefit"];
            this.lastValuationDate = _data["lastValuationDate"];
        }
    }

    static fromJS(data: any): Contribution {
        data = typeof data === 'object' ? data : {};
        let result = new Contribution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loan"] = this.loan;
        data["accumulatedValue"] = this.accumulatedValue;
        data["deathBenefit"] = this.deathBenefit;
        data["lastValuationDate"] = this.lastValuationDate;
        return data;
    }
}

export interface IContribution {
    loan: number;
    accumulatedValue: number;
    deathBenefit: number;
    lastValuationDate?: string | undefined;
}

export class Login implements ILogin {
    timestamps?: string[] | undefined;

    constructor(data?: ILogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["timestamps"])) {
                this.timestamps = [] as any;
                for (let item of _data["timestamps"])
                    this.timestamps!.push(item);
            }
        }
    }

    static fromJS(data: any): Login {
        data = typeof data === 'object' ? data : {};
        let result = new Login();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timestamps)) {
            data["timestamps"] = [];
            for (let item of this.timestamps)
                data["timestamps"].push(item);
        }
        return data;
    }
}

export interface ILogin {
    timestamps?: string[] | undefined;
}

export class Investment implements IInvestment {
    percent!: number;
    investmentName?: string | undefined;

    constructor(data?: IInvestment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percent = _data["percent"];
            this.investmentName = _data["investmentName"];
        }
    }

    static fromJS(data: any): Investment {
        data = typeof data === 'object' ? data : {};
        let result = new Investment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percent"] = this.percent;
        data["investmentName"] = this.investmentName;
        return data;
    }
}

export interface IInvestment {
    percent: number;
    investmentName?: string | undefined;
}

export class Beneficiary implements IBeneficiary {
    percent!: number;
    name?: string | undefined;

    constructor(data?: IBeneficiary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percent = _data["percent"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Beneficiary {
        data = typeof data === 'object' ? data : {};
        let result = new Beneficiary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percent"] = this.percent;
        data["name"] = this.name;
        return data;
    }
}

export interface IBeneficiary {
    percent: number;
    name?: string | undefined;
}

export class CustomReportRequestViewModel implements ICustomReportRequestViewModel {
    employerIds?: number[] | undefined;
    divisionIds?: number[] | undefined;
    carrierIds?: number[] | undefined;
    groups?: FilterGroup[] | undefined;
    addOns?: AddOn[] | undefined;

    constructor(data?: ICustomReportRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employerIds"])) {
                this.employerIds = [] as any;
                for (let item of _data["employerIds"])
                    this.employerIds!.push(item);
            }
            if (Array.isArray(_data["divisionIds"])) {
                this.divisionIds = [] as any;
                for (let item of _data["divisionIds"])
                    this.divisionIds!.push(item);
            }
            if (Array.isArray(_data["carrierIds"])) {
                this.carrierIds = [] as any;
                for (let item of _data["carrierIds"])
                    this.carrierIds!.push(item);
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(FilterGroup.fromJS(item));
            }
            if (Array.isArray(_data["addOns"])) {
                this.addOns = [] as any;
                for (let item of _data["addOns"])
                    this.addOns!.push(item);
            }
        }
    }

    static fromJS(data: any): CustomReportRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomReportRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employerIds)) {
            data["employerIds"] = [];
            for (let item of this.employerIds)
                data["employerIds"].push(item);
        }
        if (Array.isArray(this.divisionIds)) {
            data["divisionIds"] = [];
            for (let item of this.divisionIds)
                data["divisionIds"].push(item);
        }
        if (Array.isArray(this.carrierIds)) {
            data["carrierIds"] = [];
            for (let item of this.carrierIds)
                data["carrierIds"].push(item);
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.addOns)) {
            data["addOns"] = [];
            for (let item of this.addOns)
                data["addOns"].push(item);
        }
        return data;
    }
}

export interface ICustomReportRequestViewModel {
    employerIds?: number[] | undefined;
    divisionIds?: number[] | undefined;
    carrierIds?: number[] | undefined;
    groups?: FilterGroup[] | undefined;
    addOns?: AddOn[] | undefined;
}

export class FilterGroup implements IFilterGroup {
    table!: TableName;
    logic!: FilterGroupLink;
    filters?: FilterItem[] | undefined;

    constructor(data?: IFilterGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.table = _data["table"];
            this.logic = _data["logic"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterGroup {
        data = typeof data === 'object' ? data : {};
        let result = new FilterGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table"] = this.table;
        data["logic"] = this.logic;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterGroup {
    table: TableName;
    logic: FilterGroupLink;
    filters?: FilterItem[] | undefined;
}

export enum TableName {
    Policies = "Policies",
    AccountValues = "AccountValues",
    Transactions = "Transactions",
    Products = "Products",
    Investments = "Investments",
    Beneficiaries = "Beneficiaries",
    Documents = "Documents",
}

export enum FilterGroupLink {
    And = "And",
    Or = "Or",
}

export class FilterItem implements IFilterItem {
    field?: string | undefined;
    value?: string | undefined;
    operator!: FilterOperator;

    constructor(data?: IFilterItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.value = _data["value"];
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): FilterItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilterItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["value"] = this.value;
        data["operator"] = this.operator;
        return data;
    }
}

export interface IFilterItem {
    field?: string | undefined;
    value?: string | undefined;
    operator: FilterOperator;
}

export enum FilterOperator {
    Equals = "Equals",
    NotEquals = "NotEquals",
    GreaterThan = "GreaterThan",
    LessThan = "LessThan",
    Contains = "Contains",
    StartsWith = "StartsWith",
    EndsWith = "EndsWith",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    LessThanOrEqual = "LessThanOrEqual",
    In = "In",
    NotIn = "NotIn",
}

export enum AddOn {
    ClientInformation = "ClientInformation",
    PolicyDetails = "PolicyDetails",
    Contribution = "Contribution",
    LastLogin = "LastLogin",
    Product = "Product",
    Investments = "Investments",
    Beneficiaries = "Beneficiaries",
}

export class Table implements ITable {
    name?: string | undefined;
    displayName?: string | undefined;
    columns?: Column[] | undefined;

    constructor(data?: ITable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(Column.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Table {
        data = typeof data === 'object' ? data : {};
        let result = new Table();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITable {
    name?: string | undefined;
    displayName?: string | undefined;
    columns?: Column[] | undefined;
}

export class Column implements IColumn {
    name?: string | undefined;
    displayName?: string | undefined;
    type!: ColumnType;
    supportedOperators?: FilterOperator[] | undefined;

    constructor(data?: IColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            if (Array.isArray(_data["supportedOperators"])) {
                this.supportedOperators = [] as any;
                for (let item of _data["supportedOperators"])
                    this.supportedOperators!.push(item);
            }
        }
    }

    static fromJS(data: any): Column {
        data = typeof data === 'object' ? data : {};
        let result = new Column();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        if (Array.isArray(this.supportedOperators)) {
            data["supportedOperators"] = [];
            for (let item of this.supportedOperators)
                data["supportedOperators"].push(item);
        }
        return data;
    }
}

export interface IColumn {
    name?: string | undefined;
    displayName?: string | undefined;
    type: ColumnType;
    supportedOperators?: FilterOperator[] | undefined;
}

export enum ColumnType {
    String = "String",
    Number = "Number",
    DateTime = "DateTime",
    Date = "Date",
    PolicyStatus = "PolicyStatus",
    DocumentType = "DocumentType",
}

export class QueryResultsOfDivisionViewModel implements IQueryResultsOfDivisionViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: DivisionViewModel[] | undefined;

    constructor(data?: IQueryResultsOfDivisionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DivisionViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfDivisionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfDivisionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfDivisionViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: DivisionViewModel[] | undefined;
}

export class QueryResultsOfDocumentViewModel implements IQueryResultsOfDocumentViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: DocumentViewModel[] | undefined;

    constructor(data?: IQueryResultsOfDocumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DocumentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfDocumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfDocumentViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: DocumentViewModel[] | undefined;
}

export class DocumentViewModel implements IDocumentViewModel {
    id!: number;
    documentName?: string | undefined;
    documentBlobName?: string | undefined;
    documentType!: DocumentType;
    clientId?: number | undefined;
    client?: ClientViewModel | undefined;
    carrierId?: number | undefined;
    carrier?: CarrierViewModel | undefined;
    divisionId?: number | undefined;
    division?: DivisionViewModel | undefined;
    modified?: string | undefined;
    created?: string | undefined;

    constructor(data?: IDocumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
            this.documentBlobName = _data["documentBlobName"];
            this.documentType = _data["documentType"];
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? ClientViewModel.fromJS(_data["client"]) : <any>undefined;
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierViewModel.fromJS(_data["carrier"]) : <any>undefined;
            this.divisionId = _data["divisionId"];
            this.division = _data["division"] ? DivisionViewModel.fromJS(_data["division"]) : <any>undefined;
            this.modified = _data["modified"];
            this.created = _data["created"];
        }
    }

    static fromJS(data: any): DocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        data["documentBlobName"] = this.documentBlobName;
        data["documentType"] = this.documentType;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["divisionId"] = this.divisionId;
        data["division"] = this.division ? this.division.toJSON() : <any>undefined;
        data["modified"] = this.modified;
        data["created"] = this.created;
        return data;
    }
}

export interface IDocumentViewModel {
    id: number;
    documentName?: string | undefined;
    documentBlobName?: string | undefined;
    documentType: DocumentType;
    clientId?: number | undefined;
    client?: ClientViewModel | undefined;
    carrierId?: number | undefined;
    carrier?: CarrierViewModel | undefined;
    divisionId?: number | undefined;
    division?: DivisionViewModel | undefined;
    modified?: string | undefined;
    created?: string | undefined;
}

export enum DocumentType {
    ClientDocument = "ClientDocument",
    PlanDocument = "PlanDocument",
    PolicyDocument = "PolicyDocument",
    TaxDocument = "TaxDocument",
    StatementDocument = "StatementDocument",
    ClientPlanDocument = "ClientPlanDocument",
}

export enum DocumentTimeRange {
    AllTime = "AllTime",
    Past12 = "Past12",
    Past6 = "Past6",
    Past3 = "Past3",
    CurrentMonth = "CurrentMonth",
}

export class UpdateDocumentViewModel implements IUpdateDocumentViewModel {
    id!: number;
    documentName!: string;

    constructor(data?: IUpdateDocumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
        }
    }

    static fromJS(data: any): UpdateDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        return data;
    }
}

export interface IUpdateDocumentViewModel {
    id: number;
    documentName: string;
}

export class SendUpdatedDocumentsResultDto implements ISendUpdatedDocumentsResultDto {
    numberOfUsers!: number;

    constructor(data?: ISendUpdatedDocumentsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfUsers = _data["numberOfUsers"];
        }
    }

    static fromJS(data: any): SendUpdatedDocumentsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendUpdatedDocumentsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfUsers"] = this.numberOfUsers;
        return data;
    }
}

export interface ISendUpdatedDocumentsResultDto {
    numberOfUsers: number;
}

export class SendUpdatedDocumentsRequestDto implements ISendUpdatedDocumentsRequestDto {
    userId?: string | undefined;
    clientId!: number;
    documentIds?: number[] | undefined;

    constructor(data?: ISendUpdatedDocumentsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SendUpdatedDocumentsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendUpdatedDocumentsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface ISendUpdatedDocumentsRequestDto {
    userId?: string | undefined;
    clientId: number;
    documentIds?: number[] | undefined;
}

export class EmployerDetailViewModel implements IEmployerDetailViewModel {
    id!: number;
    name?: string | undefined;
    isActive!: boolean;
    divisions?: DivisionDetailViewModel[] | undefined;
    contacts?: EmployerContactViewModel[] | undefined;
    contributionMasks?: ContributionMaskViewModel[] | undefined;

    constructor(data?: IEmployerDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(DivisionDetailViewModel.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(EmployerContactViewModel.fromJS(item));
            }
            if (Array.isArray(_data["contributionMasks"])) {
                this.contributionMasks = [] as any;
                for (let item of _data["contributionMasks"])
                    this.contributionMasks!.push(ContributionMaskViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployerDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.contributionMasks)) {
            data["contributionMasks"] = [];
            for (let item of this.contributionMasks)
                data["contributionMasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployerDetailViewModel {
    id: number;
    name?: string | undefined;
    isActive: boolean;
    divisions?: DivisionDetailViewModel[] | undefined;
    contacts?: EmployerContactViewModel[] | undefined;
    contributionMasks?: ContributionMaskViewModel[] | undefined;
}

export class DivisionDetailViewModel implements IDivisionDetailViewModel {
    id!: number;
    name?: string | undefined;
    address?: string | undefined;
    planName?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    employerId!: number;
    matchingContribution!: boolean;
    percentage!: number;
    employerAdmins?: EmployerAdminViewModel[] | undefined;
    producers?: ProducerViewModel[] | undefined;
    clients?: ClientViewModel[] | undefined;
    documents?: DocumentDetailViewModel[] | undefined;

    constructor(data?: IDivisionDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.planName = _data["planName"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.employerId = _data["employerId"];
            this.matchingContribution = _data["matchingContribution"];
            this.percentage = _data["percentage"];
            if (Array.isArray(_data["employerAdmins"])) {
                this.employerAdmins = [] as any;
                for (let item of _data["employerAdmins"])
                    this.employerAdmins!.push(EmployerAdminViewModel.fromJS(item));
            }
            if (Array.isArray(_data["producers"])) {
                this.producers = [] as any;
                for (let item of _data["producers"])
                    this.producers!.push(ProducerViewModel.fromJS(item));
            }
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(ClientViewModel.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DivisionDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["planName"] = this.planName;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["employerId"] = this.employerId;
        data["matchingContribution"] = this.matchingContribution;
        data["percentage"] = this.percentage;
        if (Array.isArray(this.employerAdmins)) {
            data["employerAdmins"] = [];
            for (let item of this.employerAdmins)
                data["employerAdmins"].push(item.toJSON());
        }
        if (Array.isArray(this.producers)) {
            data["producers"] = [];
            for (let item of this.producers)
                data["producers"].push(item.toJSON());
        }
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDivisionDetailViewModel {
    id: number;
    name?: string | undefined;
    address?: string | undefined;
    planName?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    employerId: number;
    matchingContribution: boolean;
    percentage: number;
    employerAdmins?: EmployerAdminViewModel[] | undefined;
    producers?: ProducerViewModel[] | undefined;
    clients?: ClientViewModel[] | undefined;
    documents?: DocumentDetailViewModel[] | undefined;
}

export class DocumentDetailViewModel implements IDocumentDetailViewModel {
    id!: number;
    documentName?: string | undefined;
    documentBlobName?: string | undefined;
    documentType!: DocumentType;
    carrierId?: number | undefined;
    carrier?: CarrierViewModel | undefined;
    modified?: string | undefined;

    constructor(data?: IDocumentDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
            this.documentBlobName = _data["documentBlobName"];
            this.documentType = _data["documentType"];
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierViewModel.fromJS(_data["carrier"]) : <any>undefined;
            this.modified = _data["modified"];
        }
    }

    static fromJS(data: any): DocumentDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        data["documentBlobName"] = this.documentBlobName;
        data["documentType"] = this.documentType;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["modified"] = this.modified;
        return data;
    }
}

export interface IDocumentDetailViewModel {
    id: number;
    documentName?: string | undefined;
    documentBlobName?: string | undefined;
    documentType: DocumentType;
    carrierId?: number | undefined;
    carrier?: CarrierViewModel | undefined;
    modified?: string | undefined;
}

export class EmployerContactViewModel implements IEmployerContactViewModel {
    id!: number;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    divisionId!: number;
    producerId?: number | undefined;
    employerAdminId?: number | undefined;
    isActive!: boolean;
    role?: string | undefined;

    constructor(data?: IEmployerContactViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.divisionId = _data["divisionId"];
            this.producerId = _data["producerId"];
            this.employerAdminId = _data["employerAdminId"];
            this.isActive = _data["isActive"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): EmployerContactViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerContactViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["divisionId"] = this.divisionId;
        data["producerId"] = this.producerId;
        data["employerAdminId"] = this.employerAdminId;
        data["isActive"] = this.isActive;
        data["role"] = this.role;
        return data;
    }
}

export interface IEmployerContactViewModel {
    id: number;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    divisionId: number;
    producerId?: number | undefined;
    employerAdminId?: number | undefined;
    isActive: boolean;
    role?: string | undefined;
}

export class ContributionMaskViewModel implements IContributionMaskViewModel {
    id!: number;
    employerId!: number;
    type!: TransactionType;
    mask?: string | undefined;

    constructor(data?: IContributionMaskViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employerId = _data["employerId"];
            this.type = _data["type"];
            this.mask = _data["mask"];
        }
    }

    static fromJS(data: any): ContributionMaskViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContributionMaskViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employerId"] = this.employerId;
        data["type"] = this.type;
        data["mask"] = this.mask;
        return data;
    }
}

export interface IContributionMaskViewModel {
    id: number;
    employerId: number;
    type: TransactionType;
    mask?: string | undefined;
}

export enum TransactionType {
    Default = "Default",
    BaseContribution = "BaseContribution",
    BonusContribution = "BonusContribution",
    NonQualContribution = "NonQualContribution",
    OtherContribution = "OtherContribution",
    BaseContributionEE = "BaseContributionEE",
    BonusContributionEE = "BonusContributionEE",
    NonQualContributionEE = "NonQualContributionEE",
    OtherContributionEE = "OtherContributionEE",
    BaseContributionERMatch = "BaseContributionERMatch",
    BonusContributionERMatch = "BonusContributionERMatch",
    NonQualContributionERMatch = "NonQualContributionERMatch",
    OtherContributionERMatch = "OtherContributionERMatch",
    EmployerContribution = "EmployerContribution",
    LoanDisbursement = "LoanDisbursement",
    LoanRepayment = "LoanRepayment",
    LoanRepaymentEE = "LoanRepaymentEE",
    LoanRepaymentERMatch = "LoanRepaymentERMatch",
    Withdrawal = "Withdrawal",
    InterestCredit = "InterestCredit",
    Miscellaneous = "Miscellaneous",
    LoanRepaymentEmployerContribution = "LoanRepaymentEmployerContribution",
    LoanRepaymentNonQualContributionER = "LoanRepaymentNonQualContributionER",
}

export class QueryResultsOfEmployerViewModel implements IQueryResultsOfEmployerViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: EmployerViewModel[] | undefined;

    constructor(data?: IQueryResultsOfEmployerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EmployerViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfEmployerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfEmployerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfEmployerViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: EmployerViewModel[] | undefined;
}

export class EmployerRequest implements IEmployerRequest {
    id!: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    isActive!: boolean;
    contributionMasks?: ContributionMaskViewModel[] | undefined;
    divisions?: DivisionRequest[] | undefined;
    contacts?: EmployerContactRequest[] | undefined;

    constructor(data?: IEmployerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["contributionMasks"])) {
                this.contributionMasks = [] as any;
                for (let item of _data["contributionMasks"])
                    this.contributionMasks!.push(ContributionMaskViewModel.fromJS(item));
            }
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(DivisionRequest.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(EmployerContactRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["city"] = this.city;
        data["state"] = this.state;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.contributionMasks)) {
            data["contributionMasks"] = [];
            for (let item of this.contributionMasks)
                data["contributionMasks"].push(item.toJSON());
        }
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployerRequest {
    id: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    isActive: boolean;
    contributionMasks?: ContributionMaskViewModel[] | undefined;
    divisions?: DivisionRequest[] | undefined;
    contacts?: EmployerContactRequest[] | undefined;
}

export class DivisionRequest implements IDivisionRequest {
    id!: number;
    name?: string | undefined;
    planName?: string | undefined;
    address?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    employerId!: number;
    matchingContribution!: boolean;
    percentage!: number;

    constructor(data?: IDivisionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.planName = _data["planName"];
            this.address = _data["address"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.employerId = _data["employerId"];
            this.matchingContribution = _data["matchingContribution"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): DivisionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["planName"] = this.planName;
        data["address"] = this.address;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["employerId"] = this.employerId;
        data["matchingContribution"] = this.matchingContribution;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IDivisionRequest {
    id: number;
    name?: string | undefined;
    planName?: string | undefined;
    address?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    employerId: number;
    matchingContribution: boolean;
    percentage: number;
}

export class EmployerContactRequest implements IEmployerContactRequest {
    id!: number;
    name?: string | undefined;
    divisionId!: number;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    producerId?: number | undefined;
    employerAdminId?: number | undefined;

    constructor(data?: IEmployerContactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.divisionId = _data["divisionId"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.producerId = _data["producerId"];
            this.employerAdminId = _data["employerAdminId"];
        }
    }

    static fromJS(data: any): EmployerContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["divisionId"] = this.divisionId;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["producerId"] = this.producerId;
        data["employerAdminId"] = this.employerAdminId;
        return data;
    }
}

export interface IEmployerContactRequest {
    id: number;
    name?: string | undefined;
    divisionId: number;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    producerId?: number | undefined;
    employerAdminId?: number | undefined;
}

export class SendTaxDocumentsResultDto implements ISendTaxDocumentsResultDto {
    numberOfUsers!: number;

    constructor(data?: ISendTaxDocumentsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfUsers = _data["numberOfUsers"];
        }
    }

    static fromJS(data: any): SendTaxDocumentsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendTaxDocumentsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfUsers"] = this.numberOfUsers;
        return data;
    }
}

export interface ISendTaxDocumentsResultDto {
    numberOfUsers: number;
}

export class UserTaxDocumentViewModel implements IUserTaxDocumentViewModel {
    id!: number;
    user?: UserBasicViewModel | undefined;
    document?: DocumentBasicViewModel | undefined;

    constructor(data?: IUserTaxDocumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserBasicViewModel.fromJS(_data["user"]) : <any>undefined;
            this.document = _data["document"] ? DocumentBasicViewModel.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserTaxDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserTaxDocumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserTaxDocumentViewModel {
    id: number;
    user?: UserBasicViewModel | undefined;
    document?: DocumentBasicViewModel | undefined;
}

export class UserBasicViewModel implements IUserBasicViewModel {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    isActive!: boolean;

    constructor(data?: IUserBasicViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userName = _data["userName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UserBasicViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserBasicViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userName"] = this.userName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUserBasicViewModel {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    isActive: boolean;
}

export class DocumentBasicViewModel implements IDocumentBasicViewModel {
    id!: number;
    documentName?: string | undefined;
    documentType!: DocumentType;
    created?: string | undefined;
    modified?: string | undefined;

    constructor(data?: IDocumentBasicViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
            this.documentType = _data["documentType"];
            this.created = _data["created"];
            this.modified = _data["modified"];
        }
    }

    static fromJS(data: any): DocumentBasicViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentBasicViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        data["documentType"] = this.documentType;
        data["created"] = this.created;
        data["modified"] = this.modified;
        return data;
    }
}

export interface IDocumentBasicViewModel {
    id: number;
    documentName?: string | undefined;
    documentType: DocumentType;
    created?: string | undefined;
    modified?: string | undefined;
}

export class EmployeeViewModel implements IEmployeeViewModel {
    name?: string | undefined;
    storeName?: string | undefined;

    constructor(data?: IEmployeeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.storeName = _data["storeName"];
        }
    }

    static fromJS(data: any): EmployeeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["storeName"] = this.storeName;
        return data;
    }
}

export interface IEmployeeViewModel {
    name?: string | undefined;
    storeName?: string | undefined;
}

export class EmployeeQuery extends Query implements IEmployeeQuery {
    storeId?: number | undefined;

    constructor(data?: IEmployeeQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeId = _data["storeId"];
        }
    }

    static fromJS(data: any): EmployeeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        super.toJSON(data);
        return data;
    }
}

export interface IEmployeeQuery extends IQuery {
    storeId?: number | undefined;
}

export abstract class EntityBaseOfInteger implements IEntityBaseOfInteger {
    id!: number;
    created?: string | undefined;
    createdBy?: string | undefined;
    modified?: string | undefined;
    modifiedBy?: string | undefined;

    constructor(data?: IEntityBaseOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"];
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"];
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): EntityBaseOfInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBaseOfInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IEntityBaseOfInteger {
    id: number;
    created?: string | undefined;
    createdBy?: string | undefined;
    modified?: string | undefined;
    modifiedBy?: string | undefined;
}

export abstract class EntityBase extends EntityBaseOfInteger implements IEntityBase {

    constructor(data?: IEntityBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EntityBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEntityBase extends IEntityBaseOfInteger {
}

export class Employee extends EntityBase implements IEmployee {
    name?: string | undefined;
    startedOn!: string;
    store?: Store | undefined;
    documents?: DocumentCollection | undefined;

    constructor(data?: IEmployee) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.startedOn = _data["startedOn"];
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            this.documents = _data["documents"] ? DocumentCollection.fromJS(_data["documents"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startedOn"] = this.startedOn;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["documents"] = this.documents ? this.documents.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEmployee extends IEntityBase {
    name?: string | undefined;
    startedOn: string;
    store?: Store | undefined;
    documents?: DocumentCollection | undefined;
}

export class Store extends EntityBase implements IStore {
    name?: string | undefined;
    documents?: DocumentCollection | undefined;

    constructor(data?: IStore) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.documents = _data["documents"] ? DocumentCollection.fromJS(_data["documents"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Store {
        data = typeof data === 'object' ? data : {};
        let result = new Store();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["documents"] = this.documents ? this.documents.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStore extends IEntityBase {
    name?: string | undefined;
    documents?: DocumentCollection | undefined;
}

export abstract class MultiParentCollectionBaseOfDocumentAndInteger extends EntityBaseOfInteger implements IMultiParentCollectionBaseOfDocumentAndInteger {
    items?: Document[] | undefined;

    constructor(data?: IMultiParentCollectionBaseOfDocumentAndInteger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Document.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultiParentCollectionBaseOfDocumentAndInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MultiParentCollectionBaseOfDocumentAndInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMultiParentCollectionBaseOfDocumentAndInteger extends IEntityBaseOfInteger {
    items?: Document[] | undefined;
}

export abstract class MultiParentCollectionBaseOfDocument extends MultiParentCollectionBaseOfDocumentAndInteger implements IMultiParentCollectionBaseOfDocument {

    constructor(data?: IMultiParentCollectionBaseOfDocument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MultiParentCollectionBaseOfDocument {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MultiParentCollectionBaseOfDocument' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMultiParentCollectionBaseOfDocument extends IMultiParentCollectionBaseOfDocumentAndInteger {
}

export class DocumentCollection extends MultiParentCollectionBaseOfDocument implements IDocumentCollection {

    constructor(data?: IDocumentCollection) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DocumentCollection {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentCollection extends IMultiParentCollectionBaseOfDocument {
}

export class Document extends EntityBase implements IDocument {
    name?: string | undefined;
    docParent?: DocParent | undefined;

    constructor(data?: IDocument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.docParent = _data["docParent"] ? DocParent.fromJS(_data["docParent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["docParent"] = this.docParent ? this.docParent.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDocument extends IEntityBase {
    name?: string | undefined;
    docParent?: DocParent | undefined;
}

export class DocParent extends EntityBase implements IDocParent {
    name?: string | undefined;

    constructor(data?: IDocParent) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DocParent {
        data = typeof data === 'object' ? data : {};
        let result = new DocParent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IDocParent extends IEntityBase {
    name?: string | undefined;
}

export class PicklistOption implements IPicklistOption {
    id!: number;
    name?: string | undefined;
    details?: string | undefined;

    constructor(data?: IPicklistOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): PicklistOption {
        data = typeof data === 'object' ? data : {};
        let result = new PicklistOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["details"] = this.details;
        return data;
    }
}

export interface IPicklistOption {
    id: number;
    name?: string | undefined;
    details?: string | undefined;
}

export class ProgressDocumentViewModel implements IProgressDocumentViewModel {
    id!: number;
    documentName?: string | undefined;
    percentageOfCompletion!: number;
    fileType!: FileType;
    fileState!: FileState;
    succeededStates?: FileState[] | undefined;
    failType?: FailType | undefined;
    failInfo?: string | undefined;
    failIndex!: number;

    constructor(data?: IProgressDocumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
            this.percentageOfCompletion = _data["percentageOfCompletion"];
            this.fileType = _data["fileType"];
            this.fileState = _data["fileState"];
            if (Array.isArray(_data["succeededStates"])) {
                this.succeededStates = [] as any;
                for (let item of _data["succeededStates"])
                    this.succeededStates!.push(item);
            }
            this.failType = _data["failType"];
            this.failInfo = _data["failInfo"];
            this.failIndex = _data["failIndex"];
        }
    }

    static fromJS(data: any): ProgressDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressDocumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        data["percentageOfCompletion"] = this.percentageOfCompletion;
        data["fileType"] = this.fileType;
        data["fileState"] = this.fileState;
        if (Array.isArray(this.succeededStates)) {
            data["succeededStates"] = [];
            for (let item of this.succeededStates)
                data["succeededStates"].push(item);
        }
        data["failType"] = this.failType;
        data["failInfo"] = this.failInfo;
        data["failIndex"] = this.failIndex;
        return data;
    }
}

export interface IProgressDocumentViewModel {
    id: number;
    documentName?: string | undefined;
    percentageOfCompletion: number;
    fileType: FileType;
    fileState: FileState;
    succeededStates?: FileState[] | undefined;
    failType?: FailType | undefined;
    failInfo?: string | undefined;
    failIndex: number;
}

export enum FileType {
    Csv = "Csv",
}

export enum FileState {
    Unknown = "Unknown",
    Uploading = "Uploading",
    Reading = "Reading",
    Importing = "Importing",
    Cleaning = "Cleaning",
    Finished = "Finished",
    ProcessFailed = "ProcessFailed",
}

export enum FailType {
    NumberStringFormatIncorrect = "NumberStringFormatIncorrect",
    ClientNotExist = "ClientNotExist",
    EmployerNotExist = "EmployerNotExist",
    ValidatingFailed = "ValidatingFailed",
    DateStringFormatIncorrect = "DateStringFormatIncorrect",
    PolicyNumberNotExit = "PolicyNumberNotExit",
    UnknowException = "UnknowException",
    PolicyUserHasBeenDeleted = "PolicyUserHasBeenDeleted",
}

export class TransactionDocumentViewModel implements ITransactionDocumentViewModel {
    id!: number;
    fileName?: string | undefined;
    fileStatus!: FileStatus;
    modified?: string | undefined;
    uploadedBy?: string | undefined;
    publishedBy?: string | undefined;

    constructor(data?: ITransactionDocumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileStatus = _data["fileStatus"];
            this.modified = _data["modified"];
            this.uploadedBy = _data["uploadedBy"];
            this.publishedBy = _data["publishedBy"];
        }
    }

    static fromJS(data: any): TransactionDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDocumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileStatus"] = this.fileStatus;
        data["modified"] = this.modified;
        data["uploadedBy"] = this.uploadedBy;
        data["publishedBy"] = this.publishedBy;
        return data;
    }
}

export interface ITransactionDocumentViewModel {
    id: number;
    fileName?: string | undefined;
    fileStatus: FileStatus;
    modified?: string | undefined;
    uploadedBy?: string | undefined;
    publishedBy?: string | undefined;
}

export enum FileStatus {
    UnPublished = "UnPublished",
    Processing = "Processing",
    Published = "Published",
}

export class FilesUploadModel implements IFilesUploadModel {
    files?: InforFile[] | undefined;

    constructor(data?: IFilesUploadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(InforFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilesUploadModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilesUploadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilesUploadModel {
    files?: InforFile[] | undefined;
}

export class InforFile implements IInforFile {
    fileName?: string | undefined;
    createdAt?: string | undefined;

    constructor(data?: IInforFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.createdAt = _data["createdAt"];
        }
    }

    static fromJS(data: any): InforFile {
        data = typeof data === 'object' ? data : {};
        let result = new InforFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["createdAt"] = this.createdAt;
        return data;
    }
}

export interface IInforFile {
    fileName?: string | undefined;
    createdAt?: string | undefined;
}

export class InvesmentDetailViewModel implements IInvesmentDetailViewModel {
    id!: number;
    investmentName?: string | undefined;
    type?: string | undefined;
    carrierId!: number;
    percentage!: number;
    allocations?: AllocationDetailViewModel[] | undefined;

    constructor(data?: IInvesmentDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.investmentName = _data["investmentName"];
            this.type = _data["type"];
            this.carrierId = _data["carrierId"];
            this.percentage = _data["percentage"];
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(AllocationDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvesmentDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvesmentDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["investmentName"] = this.investmentName;
        data["type"] = this.type;
        data["carrierId"] = this.carrierId;
        data["percentage"] = this.percentage;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvesmentDetailViewModel {
    id: number;
    investmentName?: string | undefined;
    type?: string | undefined;
    carrierId: number;
    percentage: number;
    allocations?: AllocationDetailViewModel[] | undefined;
}

export class AllocationDetailViewModel implements IAllocationDetailViewModel {
    id!: number;
    investmentId!: number;
    carrierId!: number;
    clientName?: string | undefined;
    policyId!: number;
    policyNumber?: string | undefined;
    investmentName?: string | undefined;
    percent!: number;

    constructor(data?: IAllocationDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.investmentId = _data["investmentId"];
            this.carrierId = _data["carrierId"];
            this.clientName = _data["clientName"];
            this.policyId = _data["policyId"];
            this.policyNumber = _data["policyNumber"];
            this.investmentName = _data["investmentName"];
            this.percent = _data["percent"];
        }
    }

    static fromJS(data: any): AllocationDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["investmentId"] = this.investmentId;
        data["carrierId"] = this.carrierId;
        data["clientName"] = this.clientName;
        data["policyId"] = this.policyId;
        data["policyNumber"] = this.policyNumber;
        data["investmentName"] = this.investmentName;
        data["percent"] = this.percent;
        return data;
    }
}

export interface IAllocationDetailViewModel {
    id: number;
    investmentId: number;
    carrierId: number;
    clientName?: string | undefined;
    policyId: number;
    policyNumber?: string | undefined;
    investmentName?: string | undefined;
    percent: number;
}

export class OverViewViewModel implements IOverViewViewModel {
    year!: number;
    minYearSelected!: number;
    lastValuationDate!: string;
    lastContributionDate!: string;
    planContributions?: TotalValuePerMonth | undefined;
    totalPlanValue?: TotalValuePerMonth | undefined;
    netAccumulatedValues?: TotalValuePerMonth | undefined;
    policies?: PolicyViewModel[] | undefined;
    deathBenefits?: DeathBenefitViewModel[] | undefined;
    policyValues?: PolicyValuesViewModel[] | undefined;

    constructor(data?: IOverViewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.minYearSelected = _data["minYearSelected"];
            this.lastValuationDate = _data["lastValuationDate"];
            this.lastContributionDate = _data["lastContributionDate"];
            this.planContributions = _data["planContributions"] ? TotalValuePerMonth.fromJS(_data["planContributions"]) : <any>undefined;
            this.totalPlanValue = _data["totalPlanValue"] ? TotalValuePerMonth.fromJS(_data["totalPlanValue"]) : <any>undefined;
            this.netAccumulatedValues = _data["netAccumulatedValues"] ? TotalValuePerMonth.fromJS(_data["netAccumulatedValues"]) : <any>undefined;
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(PolicyViewModel.fromJS(item));
            }
            if (Array.isArray(_data["deathBenefits"])) {
                this.deathBenefits = [] as any;
                for (let item of _data["deathBenefits"])
                    this.deathBenefits!.push(DeathBenefitViewModel.fromJS(item));
            }
            if (Array.isArray(_data["policyValues"])) {
                this.policyValues = [] as any;
                for (let item of _data["policyValues"])
                    this.policyValues!.push(PolicyValuesViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OverViewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OverViewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["minYearSelected"] = this.minYearSelected;
        data["lastValuationDate"] = this.lastValuationDate;
        data["lastContributionDate"] = this.lastContributionDate;
        data["planContributions"] = this.planContributions ? this.planContributions.toJSON() : <any>undefined;
        data["totalPlanValue"] = this.totalPlanValue ? this.totalPlanValue.toJSON() : <any>undefined;
        data["netAccumulatedValues"] = this.netAccumulatedValues ? this.netAccumulatedValues.toJSON() : <any>undefined;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        if (Array.isArray(this.deathBenefits)) {
            data["deathBenefits"] = [];
            for (let item of this.deathBenefits)
                data["deathBenefits"].push(item.toJSON());
        }
        if (Array.isArray(this.policyValues)) {
            data["policyValues"] = [];
            for (let item of this.policyValues)
                data["policyValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOverViewViewModel {
    year: number;
    minYearSelected: number;
    lastValuationDate: string;
    lastContributionDate: string;
    planContributions?: TotalValuePerMonth | undefined;
    totalPlanValue?: TotalValuePerMonth | undefined;
    netAccumulatedValues?: TotalValuePerMonth | undefined;
    policies?: PolicyViewModel[] | undefined;
    deathBenefits?: DeathBenefitViewModel[] | undefined;
    policyValues?: PolicyValuesViewModel[] | undefined;
}

export class TotalValuePerMonth implements ITotalValuePerMonth {
    dict?: { [key: string]: number; } | undefined;
    monthLatest!: number;
    yearLatest!: number;
    latestValue!: number;
    yearCalculate!: number;
    isEmptyFirstMonth!: boolean;
    segmentMonth?: number[] | undefined;
    jan!: number;
    feb!: number;
    mar!: number;
    apr!: number;
    may!: number;
    jun!: number;
    jul!: number;
    aug!: number;
    sep!: number;
    oct!: number;
    nov!: number;
    dec!: number;

    constructor(data?: ITotalValuePerMonth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["dict"]) {
                this.dict = {} as any;
                for (let key in _data["dict"]) {
                    if (_data["dict"].hasOwnProperty(key))
                        (<any>this.dict)![key] = _data["dict"][key];
                }
            }
            this.monthLatest = _data["monthLatest"];
            this.yearLatest = _data["yearLatest"];
            this.latestValue = _data["latestValue"];
            this.yearCalculate = _data["yearCalculate"];
            this.isEmptyFirstMonth = _data["isEmptyFirstMonth"];
            if (Array.isArray(_data["segmentMonth"])) {
                this.segmentMonth = [] as any;
                for (let item of _data["segmentMonth"])
                    this.segmentMonth!.push(item);
            }
            this.jan = _data["jan"];
            this.feb = _data["feb"];
            this.mar = _data["mar"];
            this.apr = _data["apr"];
            this.may = _data["may"];
            this.jun = _data["jun"];
            this.jul = _data["jul"];
            this.aug = _data["aug"];
            this.sep = _data["sep"];
            this.oct = _data["oct"];
            this.nov = _data["nov"];
            this.dec = _data["dec"];
        }
    }

    static fromJS(data: any): TotalValuePerMonth {
        data = typeof data === 'object' ? data : {};
        let result = new TotalValuePerMonth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.dict) {
            data["dict"] = {};
            for (let key in this.dict) {
                if (this.dict.hasOwnProperty(key))
                    (<any>data["dict"])[key] = (<any>this.dict)[key];
            }
        }
        data["monthLatest"] = this.monthLatest;
        data["yearLatest"] = this.yearLatest;
        data["latestValue"] = this.latestValue;
        data["yearCalculate"] = this.yearCalculate;
        data["isEmptyFirstMonth"] = this.isEmptyFirstMonth;
        if (Array.isArray(this.segmentMonth)) {
            data["segmentMonth"] = [];
            for (let item of this.segmentMonth)
                data["segmentMonth"].push(item);
        }
        data["jan"] = this.jan;
        data["feb"] = this.feb;
        data["mar"] = this.mar;
        data["apr"] = this.apr;
        data["may"] = this.may;
        data["jun"] = this.jun;
        data["jul"] = this.jul;
        data["aug"] = this.aug;
        data["sep"] = this.sep;
        data["oct"] = this.oct;
        data["nov"] = this.nov;
        data["dec"] = this.dec;
        return data;
    }
}

export interface ITotalValuePerMonth {
    dict?: { [key: string]: number; } | undefined;
    monthLatest: number;
    yearLatest: number;
    latestValue: number;
    yearCalculate: number;
    isEmptyFirstMonth: boolean;
    segmentMonth?: number[] | undefined;
    jan: number;
    feb: number;
    mar: number;
    apr: number;
    may: number;
    jun: number;
    jul: number;
    aug: number;
    sep: number;
    oct: number;
    nov: number;
    dec: number;
}

export class BasicPolicyViewModel implements IBasicPolicyViewModel {
    id!: number;
    clientId!: number;
    clientName?: string | undefined;
    employerName?: string | undefined;
    divisionId!: number;
    divisionName?: string | undefined;
    planName?: string | undefined;
    isCoInsured!: boolean;
    coInsuredName?: string | undefined;
    coInsuredBirthDay?: string | undefined;
    matchingContribution!: boolean;
    percentage!: number;
    carrierId!: number;
    policyNumber?: string | undefined;
    agent?: string | undefined;
    loan!: number;
    carrierName?: string | undefined;
    accountLabel!: AccountLabel;
    anniversaryDate?: string | undefined;
    resetDate?: string | undefined;
    productId!: number;
    status!: PolicyStatus;
    statusAppliedAsOf?: string | undefined;
    isShowPolicy!: boolean;
    exchangedPolicyForId?: number | undefined;
    beneficiaries?: BeneficiaryDetailViewModel[] | undefined;
    investments?: InvesmentDetailViewModel[] | undefined;
    allocations?: AllocationDetailViewModel[] | undefined;
    product?: ProductViewModel | undefined;
    exchangedPolicyFor?: PolicyExchangeViewModel | undefined;

    constructor(data?: IBasicPolicyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.employerName = _data["employerName"];
            this.divisionId = _data["divisionId"];
            this.divisionName = _data["divisionName"];
            this.planName = _data["planName"];
            this.isCoInsured = _data["isCoInsured"];
            this.coInsuredName = _data["coInsuredName"];
            this.coInsuredBirthDay = _data["coInsuredBirthDay"];
            this.matchingContribution = _data["matchingContribution"];
            this.percentage = _data["percentage"];
            this.carrierId = _data["carrierId"];
            this.policyNumber = _data["policyNumber"];
            this.agent = _data["agent"];
            this.loan = _data["loan"];
            this.carrierName = _data["carrierName"];
            this.accountLabel = _data["accountLabel"];
            this.anniversaryDate = _data["anniversaryDate"];
            this.resetDate = _data["resetDate"];
            this.productId = _data["productId"];
            this.status = _data["status"];
            this.statusAppliedAsOf = _data["statusAppliedAsOf"];
            this.isShowPolicy = _data["isShowPolicy"];
            this.exchangedPolicyForId = _data["exchangedPolicyForId"];
            if (Array.isArray(_data["beneficiaries"])) {
                this.beneficiaries = [] as any;
                for (let item of _data["beneficiaries"])
                    this.beneficiaries!.push(BeneficiaryDetailViewModel.fromJS(item));
            }
            if (Array.isArray(_data["investments"])) {
                this.investments = [] as any;
                for (let item of _data["investments"])
                    this.investments!.push(InvesmentDetailViewModel.fromJS(item));
            }
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(AllocationDetailViewModel.fromJS(item));
            }
            this.product = _data["product"] ? ProductViewModel.fromJS(_data["product"]) : <any>undefined;
            this.exchangedPolicyFor = _data["exchangedPolicyFor"] ? PolicyExchangeViewModel.fromJS(_data["exchangedPolicyFor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BasicPolicyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BasicPolicyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["employerName"] = this.employerName;
        data["divisionId"] = this.divisionId;
        data["divisionName"] = this.divisionName;
        data["planName"] = this.planName;
        data["isCoInsured"] = this.isCoInsured;
        data["coInsuredName"] = this.coInsuredName;
        data["coInsuredBirthDay"] = this.coInsuredBirthDay;
        data["matchingContribution"] = this.matchingContribution;
        data["percentage"] = this.percentage;
        data["carrierId"] = this.carrierId;
        data["policyNumber"] = this.policyNumber;
        data["agent"] = this.agent;
        data["loan"] = this.loan;
        data["carrierName"] = this.carrierName;
        data["accountLabel"] = this.accountLabel;
        data["anniversaryDate"] = this.anniversaryDate;
        data["resetDate"] = this.resetDate;
        data["productId"] = this.productId;
        data["status"] = this.status;
        data["statusAppliedAsOf"] = this.statusAppliedAsOf;
        data["isShowPolicy"] = this.isShowPolicy;
        data["exchangedPolicyForId"] = this.exchangedPolicyForId;
        if (Array.isArray(this.beneficiaries)) {
            data["beneficiaries"] = [];
            for (let item of this.beneficiaries)
                data["beneficiaries"].push(item.toJSON());
        }
        if (Array.isArray(this.investments)) {
            data["investments"] = [];
            for (let item of this.investments)
                data["investments"].push(item.toJSON());
        }
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item.toJSON());
        }
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["exchangedPolicyFor"] = this.exchangedPolicyFor ? this.exchangedPolicyFor.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBasicPolicyViewModel {
    id: number;
    clientId: number;
    clientName?: string | undefined;
    employerName?: string | undefined;
    divisionId: number;
    divisionName?: string | undefined;
    planName?: string | undefined;
    isCoInsured: boolean;
    coInsuredName?: string | undefined;
    coInsuredBirthDay?: string | undefined;
    matchingContribution: boolean;
    percentage: number;
    carrierId: number;
    policyNumber?: string | undefined;
    agent?: string | undefined;
    loan: number;
    carrierName?: string | undefined;
    accountLabel: AccountLabel;
    anniversaryDate?: string | undefined;
    resetDate?: string | undefined;
    productId: number;
    status: PolicyStatus;
    statusAppliedAsOf?: string | undefined;
    isShowPolicy: boolean;
    exchangedPolicyForId?: number | undefined;
    beneficiaries?: BeneficiaryDetailViewModel[] | undefined;
    investments?: InvesmentDetailViewModel[] | undefined;
    allocations?: AllocationDetailViewModel[] | undefined;
    product?: ProductViewModel | undefined;
    exchangedPolicyFor?: PolicyExchangeViewModel | undefined;
}

export class PolicyViewModel extends BasicPolicyViewModel implements IPolicyViewModel {
    historyPoint?: HistoryPointViewModel | undefined;
    lastContributionDate?: string | undefined;
    totalContributionValue!: number;
    planContributionValue!: number;
    totalPlanValue!: number;
    isImport!: boolean;
    lastValuationDate?: string | undefined;
    netAccumulatedValues!: number;

    constructor(data?: IPolicyViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.historyPoint = _data["historyPoint"] ? HistoryPointViewModel.fromJS(_data["historyPoint"]) : <any>undefined;
            this.lastContributionDate = _data["lastContributionDate"];
            this.totalContributionValue = _data["totalContributionValue"];
            this.planContributionValue = _data["planContributionValue"];
            this.totalPlanValue = _data["totalPlanValue"];
            this.isImport = _data["isImport"];
            this.lastValuationDate = _data["lastValuationDate"];
            this.netAccumulatedValues = _data["netAccumulatedValues"];
        }
    }

    static fromJS(data: any): PolicyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["historyPoint"] = this.historyPoint ? this.historyPoint.toJSON() : <any>undefined;
        data["lastContributionDate"] = this.lastContributionDate;
        data["totalContributionValue"] = this.totalContributionValue;
        data["planContributionValue"] = this.planContributionValue;
        data["totalPlanValue"] = this.totalPlanValue;
        data["isImport"] = this.isImport;
        data["lastValuationDate"] = this.lastValuationDate;
        data["netAccumulatedValues"] = this.netAccumulatedValues;
        super.toJSON(data);
        return data;
    }
}

export interface IPolicyViewModel extends IBasicPolicyViewModel {
    historyPoint?: HistoryPointViewModel | undefined;
    lastContributionDate?: string | undefined;
    totalContributionValue: number;
    planContributionValue: number;
    totalPlanValue: number;
    isImport: boolean;
    lastValuationDate?: string | undefined;
    netAccumulatedValues: number;
}

export class HistoryPointViewModel implements IHistoryPointViewModel {
    month?: string | undefined;
    year!: number;
    loanBalance?: number | undefined;
    cashSurrenderValue?: number | undefined;
    accumulatedValue?: number | undefined;
    planDistributions?: number | undefined;
    totalContributions?: HistoricalContribution | undefined;

    constructor(data?: IHistoryPointViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
            this.loanBalance = _data["loanBalance"];
            this.cashSurrenderValue = _data["cashSurrenderValue"];
            this.accumulatedValue = _data["accumulatedValue"];
            this.planDistributions = _data["planDistributions"];
            this.totalContributions = _data["totalContributions"] ? HistoricalContribution.fromJS(_data["totalContributions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HistoryPointViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryPointViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["loanBalance"] = this.loanBalance;
        data["cashSurrenderValue"] = this.cashSurrenderValue;
        data["accumulatedValue"] = this.accumulatedValue;
        data["planDistributions"] = this.planDistributions;
        data["totalContributions"] = this.totalContributions ? this.totalContributions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHistoryPointViewModel {
    month?: string | undefined;
    year: number;
    loanBalance?: number | undefined;
    cashSurrenderValue?: number | undefined;
    accumulatedValue?: number | undefined;
    planDistributions?: number | undefined;
    totalContributions?: HistoricalContribution | undefined;
}

export class HistoricalContribution implements IHistoricalContribution {
    employeeContributions?: number | undefined;
    employerContributions?: number | undefined;
    totalContributions?: number | undefined;

    constructor(data?: IHistoricalContribution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeContributions = _data["employeeContributions"];
            this.employerContributions = _data["employerContributions"];
            this.totalContributions = _data["totalContributions"];
        }
    }

    static fromJS(data: any): HistoricalContribution {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalContribution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeContributions"] = this.employeeContributions;
        data["employerContributions"] = this.employerContributions;
        data["totalContributions"] = this.totalContributions;
        return data;
    }
}

export interface IHistoricalContribution {
    employeeContributions?: number | undefined;
    employerContributions?: number | undefined;
    totalContributions?: number | undefined;
}

export class BeneficiaryDetailViewModel implements IBeneficiaryDetailViewModel {
    id!: number;
    name?: string | undefined;
    type?: string | undefined;
    percent!: number;

    constructor(data?: IBeneficiaryDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.percent = _data["percent"];
        }
    }

    static fromJS(data: any): BeneficiaryDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["percent"] = this.percent;
        return data;
    }
}

export interface IBeneficiaryDetailViewModel {
    id: number;
    name?: string | undefined;
    type?: string | undefined;
    percent: number;
}

export class PolicyExchangeViewModel implements IPolicyExchangeViewModel {
    id!: number;
    policyNumber?: string | undefined;
    anniversaryDate?: string | undefined;
    status!: PolicyStatus;

    constructor(data?: IPolicyExchangeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.policyNumber = _data["policyNumber"];
            this.anniversaryDate = _data["anniversaryDate"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PolicyExchangeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyExchangeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["policyNumber"] = this.policyNumber;
        data["anniversaryDate"] = this.anniversaryDate;
        data["status"] = this.status;
        return data;
    }
}

export interface IPolicyExchangeViewModel {
    id: number;
    policyNumber?: string | undefined;
    anniversaryDate?: string | undefined;
    status: PolicyStatus;
}

export class DeathBenefitViewModel implements IDeathBenefitViewModel {
    id!: number;
    lastValuationDate?: string | undefined;
    carrierName?: string | undefined;
    policyNumber?: string | undefined;
    accountLabel!: AccountLabel;
    deathBenefit!: number;
    amountToPlanSponsor!: number;
    amountToBeneficiary!: number;
    beneficiary?: string | undefined;
    policyNumberExchangedFor?: string | undefined;

    constructor(data?: IDeathBenefitViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastValuationDate = _data["lastValuationDate"];
            this.carrierName = _data["carrierName"];
            this.policyNumber = _data["policyNumber"];
            this.accountLabel = _data["accountLabel"];
            this.deathBenefit = _data["deathBenefit"];
            this.amountToPlanSponsor = _data["amountToPlanSponsor"];
            this.amountToBeneficiary = _data["amountToBeneficiary"];
            this.beneficiary = _data["beneficiary"];
            this.policyNumberExchangedFor = _data["policyNumberExchangedFor"];
        }
    }

    static fromJS(data: any): DeathBenefitViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeathBenefitViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastValuationDate"] = this.lastValuationDate;
        data["carrierName"] = this.carrierName;
        data["policyNumber"] = this.policyNumber;
        data["accountLabel"] = this.accountLabel;
        data["deathBenefit"] = this.deathBenefit;
        data["amountToPlanSponsor"] = this.amountToPlanSponsor;
        data["amountToBeneficiary"] = this.amountToBeneficiary;
        data["beneficiary"] = this.beneficiary;
        data["policyNumberExchangedFor"] = this.policyNumberExchangedFor;
        return data;
    }
}

export interface IDeathBenefitViewModel {
    id: number;
    lastValuationDate?: string | undefined;
    carrierName?: string | undefined;
    policyNumber?: string | undefined;
    accountLabel: AccountLabel;
    deathBenefit: number;
    amountToPlanSponsor: number;
    amountToBeneficiary: number;
    beneficiary?: string | undefined;
    policyNumberExchangedFor?: string | undefined;
}

export class PolicyValuesViewModel implements IPolicyValuesViewModel {
    policyId!: number;
    accountLabel?: string | undefined;
    totalPlanValue?: TotalValuePerMonth | undefined;
    contributions?: TotalValuePerMonth | undefined;
    netAccumulatedValues?: TotalValuePerMonth | undefined;

    constructor(data?: IPolicyValuesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyId = _data["policyId"];
            this.accountLabel = _data["accountLabel"];
            this.totalPlanValue = _data["totalPlanValue"] ? TotalValuePerMonth.fromJS(_data["totalPlanValue"]) : <any>undefined;
            this.contributions = _data["contributions"] ? TotalValuePerMonth.fromJS(_data["contributions"]) : <any>undefined;
            this.netAccumulatedValues = _data["netAccumulatedValues"] ? TotalValuePerMonth.fromJS(_data["netAccumulatedValues"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PolicyValuesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyValuesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyId"] = this.policyId;
        data["accountLabel"] = this.accountLabel;
        data["totalPlanValue"] = this.totalPlanValue ? this.totalPlanValue.toJSON() : <any>undefined;
        data["contributions"] = this.contributions ? this.contributions.toJSON() : <any>undefined;
        data["netAccumulatedValues"] = this.netAccumulatedValues ? this.netAccumulatedValues.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPolicyValuesViewModel {
    policyId: number;
    accountLabel?: string | undefined;
    totalPlanValue?: TotalValuePerMonth | undefined;
    contributions?: TotalValuePerMonth | undefined;
    netAccumulatedValues?: TotalValuePerMonth | undefined;
}

export class MovePolicyResult implements IMovePolicyResult {
    policyId!: number;

    constructor(data?: IMovePolicyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyId = _data["policyId"];
        }
    }

    static fromJS(data: any): MovePolicyResult {
        data = typeof data === 'object' ? data : {};
        let result = new MovePolicyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyId"] = this.policyId;
        return data;
    }
}

export interface IMovePolicyResult {
    policyId: number;
}

export class MovePolicyRequest implements IMovePolicyRequest {
    policyId!: number;
    newClientId!: number;

    constructor(data?: IMovePolicyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyId = _data["policyId"];
            this.newClientId = _data["newClientId"];
        }
    }

    static fromJS(data: any): MovePolicyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MovePolicyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyId"] = this.policyId;
        data["newClientId"] = this.newClientId;
        return data;
    }
}

export interface IMovePolicyRequest {
    policyId: number;
    newClientId: number;
}

export class PlanContributionsHistory implements IPlanContributionsHistory {
    id?: string | undefined;
    carrierId!: number;
    carrierName?: string | undefined;
    policyId!: number;
    policyNumber?: string | undefined;
    date?: string | undefined;
    contributionType?: string | undefined;
    contributionTypeValue?: string | undefined;
    amount!: number;
    isExchanged!: boolean;

    constructor(data?: IPlanContributionsHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.carrierId = _data["carrierId"];
            this.carrierName = _data["carrierName"];
            this.policyId = _data["policyId"];
            this.policyNumber = _data["policyNumber"];
            this.date = _data["date"];
            this.contributionType = _data["contributionType"];
            this.contributionTypeValue = _data["contributionTypeValue"];
            this.amount = _data["amount"];
            this.isExchanged = _data["isExchanged"];
        }
    }

    static fromJS(data: any): PlanContributionsHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PlanContributionsHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["carrierId"] = this.carrierId;
        data["carrierName"] = this.carrierName;
        data["policyId"] = this.policyId;
        data["policyNumber"] = this.policyNumber;
        data["date"] = this.date;
        data["contributionType"] = this.contributionType;
        data["contributionTypeValue"] = this.contributionTypeValue;
        data["amount"] = this.amount;
        data["isExchanged"] = this.isExchanged;
        return data;
    }
}

export interface IPlanContributionsHistory {
    id?: string | undefined;
    carrierId: number;
    carrierName?: string | undefined;
    policyId: number;
    policyNumber?: string | undefined;
    date?: string | undefined;
    contributionType?: string | undefined;
    contributionTypeValue?: string | undefined;
    amount: number;
    isExchanged: boolean;
}

export class AccumulatedValuesHistory implements IAccumulatedValuesHistory {
    id?: string | undefined;
    accumulatedValueId?: string | undefined;
    loanBalanceId?: string | undefined;
    totalDeathBenefitId?: string | undefined;
    carrierId!: number;
    carrierName?: string | undefined;
    policyId!: number;
    policyNumber?: string | undefined;
    valuationDate?: string | undefined;
    accumulatedValue!: number;
    loanBalance!: number;
    totalDeathBenefit!: number;

    constructor(data?: IAccumulatedValuesHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accumulatedValueId = _data["accumulatedValueId"];
            this.loanBalanceId = _data["loanBalanceId"];
            this.totalDeathBenefitId = _data["totalDeathBenefitId"];
            this.carrierId = _data["carrierId"];
            this.carrierName = _data["carrierName"];
            this.policyId = _data["policyId"];
            this.policyNumber = _data["policyNumber"];
            this.valuationDate = _data["valuationDate"];
            this.accumulatedValue = _data["accumulatedValue"];
            this.loanBalance = _data["loanBalance"];
            this.totalDeathBenefit = _data["totalDeathBenefit"];
        }
    }

    static fromJS(data: any): AccumulatedValuesHistory {
        data = typeof data === 'object' ? data : {};
        let result = new AccumulatedValuesHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accumulatedValueId"] = this.accumulatedValueId;
        data["loanBalanceId"] = this.loanBalanceId;
        data["totalDeathBenefitId"] = this.totalDeathBenefitId;
        data["carrierId"] = this.carrierId;
        data["carrierName"] = this.carrierName;
        data["policyId"] = this.policyId;
        data["policyNumber"] = this.policyNumber;
        data["valuationDate"] = this.valuationDate;
        data["accumulatedValue"] = this.accumulatedValue;
        data["loanBalance"] = this.loanBalance;
        data["totalDeathBenefit"] = this.totalDeathBenefit;
        return data;
    }
}

export interface IAccumulatedValuesHistory {
    id?: string | undefined;
    accumulatedValueId?: string | undefined;
    loanBalanceId?: string | undefined;
    totalDeathBenefitId?: string | undefined;
    carrierId: number;
    carrierName?: string | undefined;
    policyId: number;
    policyNumber?: string | undefined;
    valuationDate?: string | undefined;
    accumulatedValue: number;
    loanBalance: number;
    totalDeathBenefit: number;
}

export class ParticipantStatementViewModel implements IParticipantStatementViewModel {
    statementDate?: string | undefined;
    planName?: string | undefined;
    planSponsor?: string | undefined;
    planAbbreviation?: string | undefined;
    participantName?: string | undefined;
    planEntryDate?: string | undefined;
    planBenefitService?: string | undefined;
    planBenefitServiceYears!: number;
    planBenefitServiceMonths!: number;
    group?: string | undefined;
    participantAddress?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    policies?: PolicyStatementViewModel[] | undefined;
    total?: PolicyStatementViewModel | undefined;

    constructor(data?: IParticipantStatementViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statementDate = _data["statementDate"];
            this.planName = _data["planName"];
            this.planSponsor = _data["planSponsor"];
            this.planAbbreviation = _data["planAbbreviation"];
            this.participantName = _data["participantName"];
            this.planEntryDate = _data["planEntryDate"];
            this.planBenefitService = _data["planBenefitService"];
            this.planBenefitServiceYears = _data["planBenefitServiceYears"];
            this.planBenefitServiceMonths = _data["planBenefitServiceMonths"];
            this.group = _data["group"];
            this.participantAddress = _data["participantAddress"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(PolicyStatementViewModel.fromJS(item));
            }
            this.total = _data["total"] ? PolicyStatementViewModel.fromJS(_data["total"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantStatementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantStatementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statementDate"] = this.statementDate;
        data["planName"] = this.planName;
        data["planSponsor"] = this.planSponsor;
        data["planAbbreviation"] = this.planAbbreviation;
        data["participantName"] = this.participantName;
        data["planEntryDate"] = this.planEntryDate;
        data["planBenefitService"] = this.planBenefitService;
        data["planBenefitServiceYears"] = this.planBenefitServiceYears;
        data["planBenefitServiceMonths"] = this.planBenefitServiceMonths;
        data["group"] = this.group;
        data["participantAddress"] = this.participantAddress;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        data["total"] = this.total ? this.total.toJSON() : <any>undefined;
        return data;
    }
}

export interface IParticipantStatementViewModel {
    statementDate?: string | undefined;
    planName?: string | undefined;
    planSponsor?: string | undefined;
    planAbbreviation?: string | undefined;
    participantName?: string | undefined;
    planEntryDate?: string | undefined;
    planBenefitService?: string | undefined;
    planBenefitServiceYears: number;
    planBenefitServiceMonths: number;
    group?: string | undefined;
    participantAddress?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    policies?: PolicyStatementViewModel[] | undefined;
    total?: PolicyStatementViewModel | undefined;
}

export class PolicyStatementViewModel implements IPolicyStatementViewModel {
    policyId!: number;
    policyNumber?: string | undefined;
    accountLabel!: AccountLabel;
    carrierName?: string | undefined;
    deathBenefit!: number;
    estimatedDeathBenefitToPlanSponsor!: number;
    estimatedDeathBenefitToBeneficiary!: number;
    reportingPeriod?: string | undefined;
    nextAnniversaryDate?: string | undefined;
    accumulatedValuesStart!: number;
    percentage!: number;
    planContributionsBase!: number;
    planContributionsBonus!: number;
    planContributionsEmployerMatch!: number;
    planContributionsTotal!: number;
    planChargesPremium!: number;
    planChargesInsuranceOther!: number;
    planChargesTotal!: number;
    planDistribution!: number;
    earnings!: number;
    accumulatedValuesEnd!: number;
    outstandingPolicyLoan!: number;
    annualizedReturn!: number;

    constructor(data?: IPolicyStatementViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyId = _data["policyId"];
            this.policyNumber = _data["policyNumber"];
            this.accountLabel = _data["accountLabel"];
            this.carrierName = _data["carrierName"];
            this.deathBenefit = _data["deathBenefit"];
            this.estimatedDeathBenefitToPlanSponsor = _data["estimatedDeathBenefitToPlanSponsor"];
            this.estimatedDeathBenefitToBeneficiary = _data["estimatedDeathBenefitToBeneficiary"];
            this.reportingPeriod = _data["reportingPeriod"];
            this.nextAnniversaryDate = _data["nextAnniversaryDate"];
            this.accumulatedValuesStart = _data["accumulatedValuesStart"];
            this.percentage = _data["percentage"];
            this.planContributionsBase = _data["planContributionsBase"];
            this.planContributionsBonus = _data["planContributionsBonus"];
            this.planContributionsEmployerMatch = _data["planContributionsEmployerMatch"];
            this.planContributionsTotal = _data["planContributionsTotal"];
            this.planChargesPremium = _data["planChargesPremium"];
            this.planChargesInsuranceOther = _data["planChargesInsuranceOther"];
            this.planChargesTotal = _data["planChargesTotal"];
            this.planDistribution = _data["planDistribution"];
            this.earnings = _data["earnings"];
            this.accumulatedValuesEnd = _data["accumulatedValuesEnd"];
            this.outstandingPolicyLoan = _data["outstandingPolicyLoan"];
            this.annualizedReturn = _data["annualizedReturn"];
        }
    }

    static fromJS(data: any): PolicyStatementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyStatementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyId"] = this.policyId;
        data["policyNumber"] = this.policyNumber;
        data["accountLabel"] = this.accountLabel;
        data["carrierName"] = this.carrierName;
        data["deathBenefit"] = this.deathBenefit;
        data["estimatedDeathBenefitToPlanSponsor"] = this.estimatedDeathBenefitToPlanSponsor;
        data["estimatedDeathBenefitToBeneficiary"] = this.estimatedDeathBenefitToBeneficiary;
        data["reportingPeriod"] = this.reportingPeriod;
        data["nextAnniversaryDate"] = this.nextAnniversaryDate;
        data["accumulatedValuesStart"] = this.accumulatedValuesStart;
        data["percentage"] = this.percentage;
        data["planContributionsBase"] = this.planContributionsBase;
        data["planContributionsBonus"] = this.planContributionsBonus;
        data["planContributionsEmployerMatch"] = this.planContributionsEmployerMatch;
        data["planContributionsTotal"] = this.planContributionsTotal;
        data["planChargesPremium"] = this.planChargesPremium;
        data["planChargesInsuranceOther"] = this.planChargesInsuranceOther;
        data["planChargesTotal"] = this.planChargesTotal;
        data["planDistribution"] = this.planDistribution;
        data["earnings"] = this.earnings;
        data["accumulatedValuesEnd"] = this.accumulatedValuesEnd;
        data["outstandingPolicyLoan"] = this.outstandingPolicyLoan;
        data["annualizedReturn"] = this.annualizedReturn;
        return data;
    }
}

export interface IPolicyStatementViewModel {
    policyId: number;
    policyNumber?: string | undefined;
    accountLabel: AccountLabel;
    carrierName?: string | undefined;
    deathBenefit: number;
    estimatedDeathBenefitToPlanSponsor: number;
    estimatedDeathBenefitToBeneficiary: number;
    reportingPeriod?: string | undefined;
    nextAnniversaryDate?: string | undefined;
    accumulatedValuesStart: number;
    percentage: number;
    planContributionsBase: number;
    planContributionsBonus: number;
    planContributionsEmployerMatch: number;
    planContributionsTotal: number;
    planChargesPremium: number;
    planChargesInsuranceOther: number;
    planChargesTotal: number;
    planDistribution: number;
    earnings: number;
    accumulatedValuesEnd: number;
    outstandingPolicyLoan: number;
    annualizedReturn: number;
}

export class StatementQuery implements IStatementQuery {
    userId?: string | undefined;
    policies?: PolicyStatementQuery[] | undefined;
    startDate!: string;
    endDate!: string;

    constructor(data?: IStatementQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(PolicyStatementQuery.fromJS(item));
            }
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): StatementQuery {
        data = typeof data === 'object' ? data : {};
        let result = new StatementQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IStatementQuery {
    userId?: string | undefined;
    policies?: PolicyStatementQuery[] | undefined;
    startDate: string;
    endDate: string;
}

export class PolicyStatementQuery implements IPolicyStatementQuery {
    id!: number;
    percentage!: number;
    earnings!: number;

    constructor(data?: IPolicyStatementQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.percentage = _data["percentage"];
            this.earnings = _data["earnings"];
        }
    }

    static fromJS(data: any): PolicyStatementQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyStatementQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["percentage"] = this.percentage;
        data["earnings"] = this.earnings;
        return data;
    }
}

export interface IPolicyStatementQuery {
    id: number;
    percentage: number;
    earnings: number;
}

export class QueryResultsOfProducerViewModel implements IQueryResultsOfProducerViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ProducerViewModel[] | undefined;

    constructor(data?: IQueryResultsOfProducerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ProducerViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfProducerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfProducerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfProducerViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ProducerViewModel[] | undefined;
}

export class ProductDetailViewModel implements IProductDetailViewModel {
    id!: number;
    productName?: string | undefined;
    carrierId!: number;
    policies?: PolicyBasicViewModel[] | undefined;

    constructor(data?: IProductDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.carrierId = _data["carrierId"];
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(PolicyBasicViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["carrierId"] = this.carrierId;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductDetailViewModel {
    id: number;
    productName?: string | undefined;
    carrierId: number;
    policies?: PolicyBasicViewModel[] | undefined;
}

export class PolicyBasicViewModel implements IPolicyBasicViewModel {
    id!: number;
    clientId!: number;
    clientName?: string | undefined;
    employerName?: string | undefined;
    divisionId!: number;
    divisionName?: string | undefined;
    planName?: string | undefined;
    isCoInsured!: boolean;
    coInsuredName?: string | undefined;
    coInsuredBirthDay?: string | undefined;
    matchingContribution!: boolean;
    percentage!: number;
    carrierId!: number;
    policyNumber?: string | undefined;
    agent?: string | undefined;
    loan!: number;
    carrierName?: string | undefined;
    accountLabel!: AccountLabel;
    anniversaryDate?: string | undefined;
    productId!: number;
    isImport!: boolean;

    constructor(data?: IPolicyBasicViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.employerName = _data["employerName"];
            this.divisionId = _data["divisionId"];
            this.divisionName = _data["divisionName"];
            this.planName = _data["planName"];
            this.isCoInsured = _data["isCoInsured"];
            this.coInsuredName = _data["coInsuredName"];
            this.coInsuredBirthDay = _data["coInsuredBirthDay"];
            this.matchingContribution = _data["matchingContribution"];
            this.percentage = _data["percentage"];
            this.carrierId = _data["carrierId"];
            this.policyNumber = _data["policyNumber"];
            this.agent = _data["agent"];
            this.loan = _data["loan"];
            this.carrierName = _data["carrierName"];
            this.accountLabel = _data["accountLabel"];
            this.anniversaryDate = _data["anniversaryDate"];
            this.productId = _data["productId"];
            this.isImport = _data["isImport"];
        }
    }

    static fromJS(data: any): PolicyBasicViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyBasicViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["employerName"] = this.employerName;
        data["divisionId"] = this.divisionId;
        data["divisionName"] = this.divisionName;
        data["planName"] = this.planName;
        data["isCoInsured"] = this.isCoInsured;
        data["coInsuredName"] = this.coInsuredName;
        data["coInsuredBirthDay"] = this.coInsuredBirthDay;
        data["matchingContribution"] = this.matchingContribution;
        data["percentage"] = this.percentage;
        data["carrierId"] = this.carrierId;
        data["policyNumber"] = this.policyNumber;
        data["agent"] = this.agent;
        data["loan"] = this.loan;
        data["carrierName"] = this.carrierName;
        data["accountLabel"] = this.accountLabel;
        data["anniversaryDate"] = this.anniversaryDate;
        data["productId"] = this.productId;
        data["isImport"] = this.isImport;
        return data;
    }
}

export interface IPolicyBasicViewModel {
    id: number;
    clientId: number;
    clientName?: string | undefined;
    employerName?: string | undefined;
    divisionId: number;
    divisionName?: string | undefined;
    planName?: string | undefined;
    isCoInsured: boolean;
    coInsuredName?: string | undefined;
    coInsuredBirthDay?: string | undefined;
    matchingContribution: boolean;
    percentage: number;
    carrierId: number;
    policyNumber?: string | undefined;
    agent?: string | undefined;
    loan: number;
    carrierName?: string | undefined;
    accountLabel: AccountLabel;
    anniversaryDate?: string | undefined;
    productId: number;
    isImport: boolean;
}

export class QueryResultsOfUserViewModel implements IQueryResultsOfUserViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: UserViewModel[] | undefined;

    constructor(data?: IQueryResultsOfUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(UserViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfUserViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: UserViewModel[] | undefined;
}

export class UserViewModel extends UserBasicViewModel implements IUserViewModel {
    statusType?: string | undefined;
    refreshToken?: string | undefined;
    notes?: string | undefined;
    role?: string | undefined;
    emailConfirmed!: boolean;
    pendingEmailChange?: UserPendingEmailChange | undefined;
    phoneNumber?: string | undefined;
    employers?: EmployerViewModel[] | undefined;
    divisions?: DivisionViewModel[] | undefined;
    policies?: PolicyViewModel[] | undefined;
    clients?: ClientViewModel[] | undefined;
    employerAdminId?: number | undefined;
    producerId?: number | undefined;
    clientId?: number | undefined;
    divisionId!: number;
    dateOfBirth?: string | undefined;
    statusAppliedAsOf?: string | undefined;
    startDate?: string | undefined;
    address?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    recentLoginLogs?: LoginLogViewModel[] | undefined;

    constructor(data?: IUserViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statusType = _data["statusType"];
            this.refreshToken = _data["refreshToken"];
            this.notes = _data["notes"];
            this.role = _data["role"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.pendingEmailChange = _data["pendingEmailChange"] ? UserPendingEmailChange.fromJS(_data["pendingEmailChange"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["employers"])) {
                this.employers = [] as any;
                for (let item of _data["employers"])
                    this.employers!.push(EmployerViewModel.fromJS(item));
            }
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(DivisionViewModel.fromJS(item));
            }
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(PolicyViewModel.fromJS(item));
            }
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(ClientViewModel.fromJS(item));
            }
            this.employerAdminId = _data["employerAdminId"];
            this.producerId = _data["producerId"];
            this.clientId = _data["clientId"];
            this.divisionId = _data["divisionId"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.statusAppliedAsOf = _data["statusAppliedAsOf"];
            this.startDate = _data["startDate"];
            this.address = _data["address"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.zip = _data["zip"];
            if (Array.isArray(_data["recentLoginLogs"])) {
                this.recentLoginLogs = [] as any;
                for (let item of _data["recentLoginLogs"])
                    this.recentLoginLogs!.push(LoginLogViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusType"] = this.statusType;
        data["refreshToken"] = this.refreshToken;
        data["notes"] = this.notes;
        data["role"] = this.role;
        data["emailConfirmed"] = this.emailConfirmed;
        data["pendingEmailChange"] = this.pendingEmailChange ? this.pendingEmailChange.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.employers)) {
            data["employers"] = [];
            for (let item of this.employers)
                data["employers"].push(item.toJSON());
        }
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item.toJSON());
        }
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        data["employerAdminId"] = this.employerAdminId;
        data["producerId"] = this.producerId;
        data["clientId"] = this.clientId;
        data["divisionId"] = this.divisionId;
        data["dateOfBirth"] = this.dateOfBirth;
        data["statusAppliedAsOf"] = this.statusAppliedAsOf;
        data["startDate"] = this.startDate;
        data["address"] = this.address;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zip"] = this.zip;
        if (Array.isArray(this.recentLoginLogs)) {
            data["recentLoginLogs"] = [];
            for (let item of this.recentLoginLogs)
                data["recentLoginLogs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUserViewModel extends IUserBasicViewModel {
    statusType?: string | undefined;
    refreshToken?: string | undefined;
    notes?: string | undefined;
    role?: string | undefined;
    emailConfirmed: boolean;
    pendingEmailChange?: UserPendingEmailChange | undefined;
    phoneNumber?: string | undefined;
    employers?: EmployerViewModel[] | undefined;
    divisions?: DivisionViewModel[] | undefined;
    policies?: PolicyViewModel[] | undefined;
    clients?: ClientViewModel[] | undefined;
    employerAdminId?: number | undefined;
    producerId?: number | undefined;
    clientId?: number | undefined;
    divisionId: number;
    dateOfBirth?: string | undefined;
    statusAppliedAsOf?: string | undefined;
    startDate?: string | undefined;
    address?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    recentLoginLogs?: LoginLogViewModel[] | undefined;
}

export class UserPendingEmailChange implements IUserPendingEmailChange {
    newEmail?: string | undefined;
    requestedOn!: string;

    constructor(data?: IUserPendingEmailChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newEmail = _data["newEmail"];
            this.requestedOn = _data["requestedOn"];
        }
    }

    static fromJS(data: any): UserPendingEmailChange {
        data = typeof data === 'object' ? data : {};
        let result = new UserPendingEmailChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newEmail"] = this.newEmail;
        data["requestedOn"] = this.requestedOn;
        return data;
    }
}

export interface IUserPendingEmailChange {
    newEmail?: string | undefined;
    requestedOn: string;
}

export class LoginLogViewModel implements ILoginLogViewModel {
    id!: number;
    userId?: string | undefined;
    timestamp!: string;

    constructor(data?: ILoginLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): LoginLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface ILoginLogViewModel {
    id: number;
    userId?: string | undefined;
    timestamp: string;
}

export class PlanContributionViewModel implements IPlanContributionViewModel {
    carriers?: CarrierViewModel[] | undefined;
    policies?: PolicyDetailViewModel[] | undefined;
    planContributionHistory?: PlanContributionsHistory[] | undefined;
    accumulatedValuesHistory?: AccumulatedValuesHistory[] | undefined;

    constructor(data?: IPlanContributionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["carriers"])) {
                this.carriers = [] as any;
                for (let item of _data["carriers"])
                    this.carriers!.push(CarrierViewModel.fromJS(item));
            }
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(PolicyDetailViewModel.fromJS(item));
            }
            if (Array.isArray(_data["planContributionHistory"])) {
                this.planContributionHistory = [] as any;
                for (let item of _data["planContributionHistory"])
                    this.planContributionHistory!.push(PlanContributionsHistory.fromJS(item));
            }
            if (Array.isArray(_data["accumulatedValuesHistory"])) {
                this.accumulatedValuesHistory = [] as any;
                for (let item of _data["accumulatedValuesHistory"])
                    this.accumulatedValuesHistory!.push(AccumulatedValuesHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlanContributionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlanContributionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.carriers)) {
            data["carriers"] = [];
            for (let item of this.carriers)
                data["carriers"].push(item.toJSON());
        }
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        if (Array.isArray(this.planContributionHistory)) {
            data["planContributionHistory"] = [];
            for (let item of this.planContributionHistory)
                data["planContributionHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.accumulatedValuesHistory)) {
            data["accumulatedValuesHistory"] = [];
            for (let item of this.accumulatedValuesHistory)
                data["accumulatedValuesHistory"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlanContributionViewModel {
    carriers?: CarrierViewModel[] | undefined;
    policies?: PolicyDetailViewModel[] | undefined;
    planContributionHistory?: PlanContributionsHistory[] | undefined;
    accumulatedValuesHistory?: AccumulatedValuesHistory[] | undefined;
}

export class PolicyDetailViewModel implements IPolicyDetailViewModel {
    id!: number;
    policyNumber?: string | undefined;
    accountLabel!: AccountLabel;
    anniversaryDate?: string | undefined;
    resetDate?: string | undefined;
    coInsuredName?: string | undefined;
    coInsuredBirthDay?: string | undefined;
    isImport!: boolean;
    clientId!: number;
    clientName?: string | undefined;
    client?: ClientViewModel | undefined;
    status!: PolicyStatus;
    statusAppliedAsOf?: string | undefined;
    beneficiaries?: BeneficiaryDetailViewModel[] | undefined;
    allocations?: AllocationDetailViewModel[] | undefined;
    product?: ProductViewModel | undefined;
    carrierId!: number;
    carrier?: CarrierViewModel | undefined;
    exchangedPolicyFor?: PolicyExchangeViewModel | undefined;

    constructor(data?: IPolicyDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.policyNumber = _data["policyNumber"];
            this.accountLabel = _data["accountLabel"];
            this.anniversaryDate = _data["anniversaryDate"];
            this.resetDate = _data["resetDate"];
            this.coInsuredName = _data["coInsuredName"];
            this.coInsuredBirthDay = _data["coInsuredBirthDay"];
            this.isImport = _data["isImport"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.client = _data["client"] ? ClientViewModel.fromJS(_data["client"]) : <any>undefined;
            this.status = _data["status"];
            this.statusAppliedAsOf = _data["statusAppliedAsOf"];
            if (Array.isArray(_data["beneficiaries"])) {
                this.beneficiaries = [] as any;
                for (let item of _data["beneficiaries"])
                    this.beneficiaries!.push(BeneficiaryDetailViewModel.fromJS(item));
            }
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(AllocationDetailViewModel.fromJS(item));
            }
            this.product = _data["product"] ? ProductViewModel.fromJS(_data["product"]) : <any>undefined;
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierViewModel.fromJS(_data["carrier"]) : <any>undefined;
            this.exchangedPolicyFor = _data["exchangedPolicyFor"] ? PolicyExchangeViewModel.fromJS(_data["exchangedPolicyFor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PolicyDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["policyNumber"] = this.policyNumber;
        data["accountLabel"] = this.accountLabel;
        data["anniversaryDate"] = this.anniversaryDate;
        data["resetDate"] = this.resetDate;
        data["coInsuredName"] = this.coInsuredName;
        data["coInsuredBirthDay"] = this.coInsuredBirthDay;
        data["isImport"] = this.isImport;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusAppliedAsOf"] = this.statusAppliedAsOf;
        if (Array.isArray(this.beneficiaries)) {
            data["beneficiaries"] = [];
            for (let item of this.beneficiaries)
                data["beneficiaries"].push(item.toJSON());
        }
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item.toJSON());
        }
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["exchangedPolicyFor"] = this.exchangedPolicyFor ? this.exchangedPolicyFor.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPolicyDetailViewModel {
    id: number;
    policyNumber?: string | undefined;
    accountLabel: AccountLabel;
    anniversaryDate?: string | undefined;
    resetDate?: string | undefined;
    coInsuredName?: string | undefined;
    coInsuredBirthDay?: string | undefined;
    isImport: boolean;
    clientId: number;
    clientName?: string | undefined;
    client?: ClientViewModel | undefined;
    status: PolicyStatus;
    statusAppliedAsOf?: string | undefined;
    beneficiaries?: BeneficiaryDetailViewModel[] | undefined;
    allocations?: AllocationDetailViewModel[] | undefined;
    product?: ProductViewModel | undefined;
    carrierId: number;
    carrier?: CarrierViewModel | undefined;
    exchangedPolicyFor?: PolicyExchangeViewModel | undefined;
}

export class PlanContributionHistoryRequest implements IPlanContributionHistoryRequest {
    id?: string | undefined;
    carrierId!: number;
    contributionTypeValue!: TransactionType;
    policyId!: number;
    date!: string;
    amount!: number;

    constructor(data?: IPlanContributionHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.carrierId = _data["carrierId"];
            this.contributionTypeValue = _data["contributionTypeValue"];
            this.policyId = _data["policyId"];
            this.date = _data["date"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): PlanContributionHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PlanContributionHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["carrierId"] = this.carrierId;
        data["contributionTypeValue"] = this.contributionTypeValue;
        data["policyId"] = this.policyId;
        data["date"] = this.date;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IPlanContributionHistoryRequest {
    id?: string | undefined;
    carrierId: number;
    contributionTypeValue: TransactionType;
    policyId: number;
    date: string;
    amount: number;
}

export class AccumulatedValuesHistoryRequest implements IAccumulatedValuesHistoryRequest {
    id?: string | undefined;
    accumulatedValueId?: string | undefined;
    loanBalanceId?: string | undefined;
    totalDeathBenefitId?: string | undefined;
    policyId!: number;
    policyNumber?: string | undefined;
    valuationDate?: string | undefined;
    accumulatedValue!: number;
    loanBalance!: number;
    totalDeathBenefit!: number;

    constructor(data?: IAccumulatedValuesHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accumulatedValueId = _data["accumulatedValueId"];
            this.loanBalanceId = _data["loanBalanceId"];
            this.totalDeathBenefitId = _data["totalDeathBenefitId"];
            this.policyId = _data["policyId"];
            this.policyNumber = _data["policyNumber"];
            this.valuationDate = _data["valuationDate"];
            this.accumulatedValue = _data["accumulatedValue"];
            this.loanBalance = _data["loanBalance"];
            this.totalDeathBenefit = _data["totalDeathBenefit"];
        }
    }

    static fromJS(data: any): AccumulatedValuesHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccumulatedValuesHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accumulatedValueId"] = this.accumulatedValueId;
        data["loanBalanceId"] = this.loanBalanceId;
        data["totalDeathBenefitId"] = this.totalDeathBenefitId;
        data["policyId"] = this.policyId;
        data["policyNumber"] = this.policyNumber;
        data["valuationDate"] = this.valuationDate;
        data["accumulatedValue"] = this.accumulatedValue;
        data["loanBalance"] = this.loanBalance;
        data["totalDeathBenefit"] = this.totalDeathBenefit;
        return data;
    }
}

export interface IAccumulatedValuesHistoryRequest {
    id?: string | undefined;
    accumulatedValueId?: string | undefined;
    loanBalanceId?: string | undefined;
    totalDeathBenefitId?: string | undefined;
    policyId: number;
    policyNumber?: string | undefined;
    valuationDate?: string | undefined;
    accumulatedValue: number;
    loanBalance: number;
    totalDeathBenefit: number;
}

export class ChangeEmailRequest implements IChangeEmailRequest {
    id?: string | undefined;
    newEmail?: string | undefined;

    constructor(data?: IChangeEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newEmail = _data["newEmail"];
        }
    }

    static fromJS(data: any): ChangeEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newEmail"] = this.newEmail;
        return data;
    }
}

export interface IChangeEmailRequest {
    id?: string | undefined;
    newEmail?: string | undefined;
}

export class UserEmailValidationResult implements IUserEmailValidationResult {
    ownedBy?: string | undefined;
    ownerIsDeleted?: boolean | undefined;

    constructor(data?: IUserEmailValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownedBy = _data["ownedBy"];
            this.ownerIsDeleted = _data["ownerIsDeleted"];
        }
    }

    static fromJS(data: any): UserEmailValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmailValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownedBy"] = this.ownedBy;
        data["ownerIsDeleted"] = this.ownerIsDeleted;
        return data;
    }
}

export interface IUserEmailValidationResult {
    ownedBy?: string | undefined;
    ownerIsDeleted?: boolean | undefined;
}

export class ValidateUserEmailRequest implements IValidateUserEmailRequest {
    id?: string | undefined;
    email?: string | undefined;

    constructor(data?: IValidateUserEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ValidateUserEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateUserEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        return data;
    }
}

export interface IValidateUserEmailRequest {
    id?: string | undefined;
    email?: string | undefined;
}

export class UnarchiveUserRequest implements IUnarchiveUserRequest {
    id?: string | undefined;

    constructor(data?: IUnarchiveUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UnarchiveUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnarchiveUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUnarchiveUserRequest {
    id?: string | undefined;
}

export class UserViewModelWithChanges implements IUserViewModelWithChanges {
    user?: UserViewModel | undefined;
    changedProperties?: ChangeProperty[] | undefined;

    constructor(data?: IUserViewModelWithChanges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserViewModel.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["changedProperties"])) {
                this.changedProperties = [] as any;
                for (let item of _data["changedProperties"])
                    this.changedProperties!.push(ChangeProperty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserViewModelWithChanges {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModelWithChanges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.changedProperties)) {
            data["changedProperties"] = [];
            for (let item of this.changedProperties)
                data["changedProperties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserViewModelWithChanges {
    user?: UserViewModel | undefined;
    changedProperties?: ChangeProperty[] | undefined;
}

export class ChangeProperty implements IChangeProperty {
    group?: string | undefined;
    propertyName?: string | undefined;
    originalValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IChangeProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.propertyName = _data["propertyName"];
            this.originalValue = _data["originalValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): ChangeProperty {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["propertyName"] = this.propertyName;
        data["originalValue"] = this.originalValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IChangeProperty {
    group?: string | undefined;
    propertyName?: string | undefined;
    originalValue?: string | undefined;
    newValue?: string | undefined;
}

export class UserRequest implements IUserRequest {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive!: boolean;
    statusType?: string | undefined;
    emailConfirmed!: boolean;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    divisions?: UserDivisionRequest[] | undefined;
    policies?: UserPolicyRequest[] | undefined;
    role?: string | undefined;
    notes?: string | undefined;
    dateOfBirth?: string | undefined;
    startDate?: string | undefined;
    statusAppliedAsOf?: string | undefined;
    address?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    employerAdminId?: number | undefined;
    producerId?: number | undefined;
    clientId?: number | undefined;

    constructor(data?: IUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isActive = _data["isActive"];
            this.statusType = _data["statusType"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(UserDivisionRequest.fromJS(item));
            }
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(UserPolicyRequest.fromJS(item));
            }
            this.role = _data["role"];
            this.notes = _data["notes"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.startDate = _data["startDate"];
            this.statusAppliedAsOf = _data["statusAppliedAsOf"];
            this.address = _data["address"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.zip = _data["zip"];
            this.employerAdminId = _data["employerAdminId"];
            this.producerId = _data["producerId"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): UserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isActive"] = this.isActive;
        data["statusType"] = this.statusType;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item.toJSON());
        }
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        data["role"] = this.role;
        data["notes"] = this.notes;
        data["dateOfBirth"] = this.dateOfBirth;
        data["startDate"] = this.startDate;
        data["statusAppliedAsOf"] = this.statusAppliedAsOf;
        data["address"] = this.address;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zip"] = this.zip;
        data["employerAdminId"] = this.employerAdminId;
        data["producerId"] = this.producerId;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IUserRequest {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive: boolean;
    statusType?: string | undefined;
    emailConfirmed: boolean;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    divisions?: UserDivisionRequest[] | undefined;
    policies?: UserPolicyRequest[] | undefined;
    role?: string | undefined;
    notes?: string | undefined;
    dateOfBirth?: string | undefined;
    startDate?: string | undefined;
    statusAppliedAsOf?: string | undefined;
    address?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    employerAdminId?: number | undefined;
    producerId?: number | undefined;
    clientId?: number | undefined;
}

export class UserPolicyRequest implements IUserPolicyRequest {
    clientId!: number;
    divisionId!: number;
    id!: number;
    accountLabel!: AccountLabel;
    anniversaryDate?: string | undefined;
    resetDate?: string | undefined;
    policyNumber?: string | undefined;
    isCoInsured!: boolean;
    coInsuredName?: string | undefined;
    coInsuredBirthDay?: string | undefined;
    status!: PolicyStatus;
    statusAppliedAsOf?: string | undefined;
    carriers?: UserCarrierRequest | undefined;
    exchangedPolicyFor?: ExchangedPolicyRequest | undefined;
    allocations?: UserAllocationRequest[] | undefined;
    product?: CarrierProductRequest | undefined;
    beneficiaries?: UserBeneficiaryRequest[] | undefined;

    constructor(data?: IUserPolicyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.divisionId = _data["divisionId"];
            this.id = _data["id"];
            this.accountLabel = _data["accountLabel"];
            this.anniversaryDate = _data["anniversaryDate"];
            this.resetDate = _data["resetDate"];
            this.policyNumber = _data["policyNumber"];
            this.isCoInsured = _data["isCoInsured"];
            this.coInsuredName = _data["coInsuredName"];
            this.coInsuredBirthDay = _data["coInsuredBirthDay"];
            this.status = _data["status"];
            this.statusAppliedAsOf = _data["statusAppliedAsOf"];
            this.carriers = _data["carriers"] ? UserCarrierRequest.fromJS(_data["carriers"]) : <any>undefined;
            this.exchangedPolicyFor = _data["exchangedPolicyFor"] ? ExchangedPolicyRequest.fromJS(_data["exchangedPolicyFor"]) : <any>undefined;
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(UserAllocationRequest.fromJS(item));
            }
            this.product = _data["product"] ? CarrierProductRequest.fromJS(_data["product"]) : <any>undefined;
            if (Array.isArray(_data["beneficiaries"])) {
                this.beneficiaries = [] as any;
                for (let item of _data["beneficiaries"])
                    this.beneficiaries!.push(UserBeneficiaryRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPolicyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserPolicyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["divisionId"] = this.divisionId;
        data["id"] = this.id;
        data["accountLabel"] = this.accountLabel;
        data["anniversaryDate"] = this.anniversaryDate;
        data["resetDate"] = this.resetDate;
        data["policyNumber"] = this.policyNumber;
        data["isCoInsured"] = this.isCoInsured;
        data["coInsuredName"] = this.coInsuredName;
        data["coInsuredBirthDay"] = this.coInsuredBirthDay;
        data["status"] = this.status;
        data["statusAppliedAsOf"] = this.statusAppliedAsOf;
        data["carriers"] = this.carriers ? this.carriers.toJSON() : <any>undefined;
        data["exchangedPolicyFor"] = this.exchangedPolicyFor ? this.exchangedPolicyFor.toJSON() : <any>undefined;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item.toJSON());
        }
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        if (Array.isArray(this.beneficiaries)) {
            data["beneficiaries"] = [];
            for (let item of this.beneficiaries)
                data["beneficiaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserPolicyRequest {
    clientId: number;
    divisionId: number;
    id: number;
    accountLabel: AccountLabel;
    anniversaryDate?: string | undefined;
    resetDate?: string | undefined;
    policyNumber?: string | undefined;
    isCoInsured: boolean;
    coInsuredName?: string | undefined;
    coInsuredBirthDay?: string | undefined;
    status: PolicyStatus;
    statusAppliedAsOf?: string | undefined;
    carriers?: UserCarrierRequest | undefined;
    exchangedPolicyFor?: ExchangedPolicyRequest | undefined;
    allocations?: UserAllocationRequest[] | undefined;
    product?: CarrierProductRequest | undefined;
    beneficiaries?: UserBeneficiaryRequest[] | undefined;
}

export class UserCarrierRequest implements IUserCarrierRequest {
    id!: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    isActive!: boolean;

    constructor(data?: IUserCarrierRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UserCarrierRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserCarrierRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["city"] = this.city;
        data["state"] = this.state;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUserCarrierRequest {
    id: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    isActive: boolean;
}

export class ExchangedPolicyRequest implements IExchangedPolicyRequest {
    id!: number;
    policyNumber?: string | undefined;

    constructor(data?: IExchangedPolicyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.policyNumber = _data["policyNumber"];
        }
    }

    static fromJS(data: any): ExchangedPolicyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangedPolicyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["policyNumber"] = this.policyNumber;
        return data;
    }
}

export interface IExchangedPolicyRequest {
    id: number;
    policyNumber?: string | undefined;
}

export class UserAllocationRequest implements IUserAllocationRequest {
    id!: number;
    investmentId!: number;
    carrierId!: number;
    policyId!: number;
    investmentName?: string | undefined;
    percent!: number;

    constructor(data?: IUserAllocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.investmentId = _data["investmentId"];
            this.carrierId = _data["carrierId"];
            this.policyId = _data["policyId"];
            this.investmentName = _data["investmentName"];
            this.percent = _data["percent"];
        }
    }

    static fromJS(data: any): UserAllocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserAllocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["investmentId"] = this.investmentId;
        data["carrierId"] = this.carrierId;
        data["policyId"] = this.policyId;
        data["investmentName"] = this.investmentName;
        data["percent"] = this.percent;
        return data;
    }
}

export interface IUserAllocationRequest {
    id: number;
    investmentId: number;
    carrierId: number;
    policyId: number;
    investmentName?: string | undefined;
    percent: number;
}

export class UserBeneficiaryRequest implements IUserBeneficiaryRequest {
    id!: number;
    name?: string | undefined;
    type?: string | undefined;
    percent!: number;

    constructor(data?: IUserBeneficiaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.percent = _data["percent"];
        }
    }

    static fromJS(data: any): UserBeneficiaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserBeneficiaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["percent"] = this.percent;
        return data;
    }
}

export interface IUserBeneficiaryRequest {
    id: number;
    name?: string | undefined;
    type?: string | undefined;
    percent: number;
}

export class ToggleUserRequest implements IToggleUserRequest {
    isActive!: boolean;
    newEmployersProducers?: NewEmployerProducer[] | undefined;

    constructor(data?: IToggleUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["newEmployersProducers"])) {
                this.newEmployersProducers = [] as any;
                for (let item of _data["newEmployersProducers"])
                    this.newEmployersProducers!.push(NewEmployerProducer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ToggleUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        if (Array.isArray(this.newEmployersProducers)) {
            data["newEmployersProducers"] = [];
            for (let item of this.newEmployersProducers)
                data["newEmployersProducers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IToggleUserRequest {
    isActive: boolean;
    newEmployersProducers?: NewEmployerProducer[] | undefined;
}

export class NewEmployerProducer implements INewEmployerProducer {
    employerId!: string;
    producerId?: string | undefined;

    constructor(data?: INewEmployerProducer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerId = _data["employerId"];
            this.producerId = _data["producerId"];
        }
    }

    static fromJS(data: any): NewEmployerProducer {
        data = typeof data === 'object' ? data : {};
        let result = new NewEmployerProducer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerId"] = this.employerId;
        data["producerId"] = this.producerId;
        return data;
    }
}

export interface INewEmployerProducer {
    employerId: string;
    producerId?: string | undefined;
}

export class ValidateTokenRequest implements IValidateTokenRequest {
    token?: string | undefined;
    resetPassword?: boolean | undefined;

    constructor(data?: IValidateTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.resetPassword = _data["resetPassword"];
        }
    }

    static fromJS(data: any): ValidateTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["resetPassword"] = this.resetPassword;
        return data;
    }
}

export interface IValidateTokenRequest {
    token?: string | undefined;
    resetPassword?: boolean | undefined;
}

export class SetNewPasswordRequest implements ISetNewPasswordRequest {
    userEmail?: string | undefined;
    password?: string | undefined;
    token?: string | undefined;

    constructor(data?: ISetNewPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["userEmail"];
            this.password = _data["password"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SetNewPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetNewPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEmail"] = this.userEmail;
        data["password"] = this.password;
        data["token"] = this.token;
        return data;
    }
}

export interface ISetNewPasswordRequest {
    userEmail?: string | undefined;
    password?: string | undefined;
    token?: string | undefined;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email!: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IForgotPasswordRequest {
    email: string;
}

export class DeletedUserViewModel implements IDeletedUserViewModel {
    id!: number;
    userId?: string | undefined;
    deletedDate?: string | undefined;
    isDeleted!: boolean;

    constructor(data?: IDeletedUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.deletedDate = _data["deletedDate"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): DeletedUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletedUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["deletedDate"] = this.deletedDate;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IDeletedUserViewModel {
    id: number;
    userId?: string | undefined;
    deletedDate?: string | undefined;
    isDeleted: boolean;
}

export class ChangesAlertRequest implements IChangesAlertRequest {
    userId?: string | undefined;
    changedProperties?: ChangeProperty[] | undefined;

    constructor(data?: IChangesAlertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["changedProperties"])) {
                this.changedProperties = [] as any;
                for (let item of _data["changedProperties"])
                    this.changedProperties!.push(ChangeProperty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChangesAlertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangesAlertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.changedProperties)) {
            data["changedProperties"] = [];
            for (let item of this.changedProperties)
                data["changedProperties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChangesAlertRequest {
    userId?: string | undefined;
    changedProperties?: ChangeProperty[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}